import { Injectable, NgZone }               from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse }				from '@angular/common/http';
import { Router } from '@angular/router';
import { ChatChannel, ChatMessage } from './signalr-chat.service';

import moment from 'moment-timezone';
import md5 from 'md5';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { IMySingleDateModel } from '../types/mydatepicker.stub';
import { TanzeelDateUtil, TanzeelDateInput } from '../../date/tanzeel-date.util';
import { Observable, timeout } from 'rxjs';
declare var gtag: any;
declare var fbq: any;
@Injectable(	{ providedIn : 'root'})
export class CommonAdminService {	

	tanzeel: any = window["DATA"];
	contextPath:string = this.tanzeel.contextPath;

	hostName: string = `${window.location.protocol}//${window.location.hostname}`;

    constructor(private http: HttpClient, private ngZone: NgZone, private router: Router){

	}

	private invokeOwnerCallback(callback: any, owner: any, ...args: any[]): void {
		if (callback == null) {
			return;
		}
		this.ngZone.run(() => callback.apply(owner, args));
	}

	parseJsonBody(body:any):any {
		if( body == null || body === '' ){
			return null;
		}
		if( typeof body === 'string' ){
			try {
				return JSON.parse(body);
			} catch (e) {
				return body;
			}
		}
		return body;
	}

	private wrapHttpResponse(status:number , body:any , headers:any):any {
		const parsed = this.parseJsonBody(body);
		return {
			_body : parsed,
			json : () => parsed,
			status : status,
			headers : headers
		};
	}

    clearStudentBrowserCache(): Observable<HttpResponse<void>> {
        const base = this.newContextPath;
        const endpoint = new URL('students/browser-recovery/clear-cache',
            new URL(base.endsWith('/') ? base : base + '/', window.location.origin));
        if (endpoint.origin !== window.location.origin) {
            throw new Error('Cache recovery requires a same-origin API proxy.');
        }
        // This anonymous recovery call deliberately omits bearer-token injection:
        // an expired login must not prevent browser-cache recovery.
        return this.http.post<void>(endpoint.href, null, {
            observe: 'response',
            headers: new HttpHeaders().set('Cache-Control', 'no-store'),
        }).pipe(timeout(15000));
    }

	get newContextPath(){
		if(!/localhost/.test(document.location.host)) {
			return "/api/";
		}else{
			return"http://localhost:5235/";

		}
	}

	get omsContextPath(){
		if(this.tanzeel != null && this.tanzeel.omsContextPath != null && this.tanzeel.omsContextPath !== ''){
			return this.tanzeel.omsContextPath;
		}
		if(!/localhost/.test(document.location.host)) {
			return "/oms-api/";
		}else{
			return "http://localhost:5236/";
		}
	}

	handleAuthenticationFailure(){
		sessionStorage.removeItem("jwt_token");
		window.location.href = "/#/boarding/loginUser";
	}

	isJwtExpired(token:any):boolean{
		if( token == null || token === '' ){
			return false;
		}

		try {
			var tokenDecoded = this.decodeJwt( token );
			if( tokenDecoded == null || tokenDecoded.exp == null ){
				return false;
			}

			return (tokenDecoded.exp * 1000) <= Date.now();
		} catch (e) {
			return true;
		}
	}

	clearExpiredJwtToken(){
		const token = sessionStorage.getItem('jwt_token');
		if( token != null && token !== '' && this.isJwtExpired(token) ){
			sessionStorage.removeItem('jwt_token');
		}
	}

	isHelpContactRoute():boolean {
		return this.router.url.indexOf('helpcontact') !== -1
			|| window.location.href.indexOf('/student/r/helpcontact') !== -1
			|| window.location.hash.indexOf('/student/r/helpcontact') !== -1;
	}

	isAnonymousSupportTicketUrl(url:string):boolean {
		if( url == null ){
			return false;
		}
		return url.indexOf('system/supportticket/initialdetails') !== -1
			|| url.indexOf('system/supportticket/sendotp/verifyNumber') !== -1
			|| url.indexOf('system/supportticket/verifyotp/') !== -1
			|| url.indexOf('system/save/supportticket') !== -1;
	}

	isPublicAuthUrl(url?:string):boolean {
		if( url == null ){
			return false;
		}
		return url.indexOf('common/auth/') !== -1
			|| url.indexOf('oauth/') !== -1
			|| url.indexOf('students/register') !== -1;
	}

	// Used for HTTP 401 only. HTTP 403 is delivered to the caller without clearing the session.
	shouldRedirectOnHttpAuthFailure(url?:string):boolean {
		if( this.isHelpContactRoute() ){
			return false;
		}
		if( url != null && this.isAnonymousSupportTicketUrl(url) ){
			return false;
		}
		if( url != null && this.isPublicAuthUrl(url) ){
			return false;
		}
		// Permission denied on this endpoint is not a session failure; keep the user logged in.
		if( url != null && url.indexOf('teachers/availability/delete-requests') !== -1 ){
			return false;
		}
		return true;
	}

	getJwtTokenForRequest(url?:string):any {
		const token = sessionStorage.getItem('jwt_token');
		if( token == null || token === '' ){
			return null;
		}
		if( this.isJwtExpired(token) ){
			if( url != null && (this.isAnonymousSupportTicketUrl(url) || this.isHelpContactRoute()) ){
				return null;
			}
			this.handleAuthenticationFailure();
			return null;
		}
		return token;
	}

	getValidJwtToken(suppressExpiredRedirect?:boolean):any{
		const token = sessionStorage.getItem('jwt_token');
		if( token == null || token === '' ){
			return null;
		}

		if( this.isJwtExpired( token ) ){
			if( suppressExpiredRedirect !== true ){
				this.handleAuthenticationFailure();
			}
			return null;
		}

		return token;
	}

	getTrialCsrfHeader():HttpHeaders{
		let trialCsrfHeaders = new HttpHeaders()
		.set(  'device-id' , '1122334455' )
		.set(  'auth-key' , md5('TANZEEL_MOBILE_APP_REGISTER_CODE_11223344_1122334455' ) );

		return trialCsrfHeaders;
	}

	createMockHttpResponse(body:any, status?:number){
		return {
			_body : body,
			json : ()=>{ return body; },
			status : status != null ? status : 200,
			headers : null
		};
	}

	getSystemDefaultMockStorageKey(){
		return 'mock.systemdefault.settings';
	}

	getDefaultMockSystemDefaultSettings(){
		return {
			id : 1,
			disableCourseSubscription : 'N',
			maxClassPerWeek : 2,
			ratePerClass : 0,
			maxClassPerDay : 1,
			timeSlotBlockMts : 30,
			gracePeriodWeeks : 1,
			freeSlotsNewStud : 0,
			quoteSelDate : null,
			quoteSelDateStr : null,
			lastQuoteIndex : 0,
			enableAuditing : 'N',
			auditLevel : 0,
			lastSchedulerRun : null,
			lastSchedulerRunStr : null,
			lastSchedulerStart : null,
			lastSchedulerStartStr : null,
			defaultTeacherTZ : 'UTC',
			defaultCourseId : null,
			disableRegistration : false,
			disableRegistrationReason : '',
			disableRescheduling : false,
			disableReschedulingReason : '',
			disableCreditAssignment : false,
			showStrapiComponents : false,
			delete : false
		};
	}

	getStoredMockSystemDefaultSettings(){
		let settings = this.getCachedObject(this.getSystemDefaultMockStorageKey());
		if( settings == null ){
			settings = this.getDefaultMockSystemDefaultSettings();
			this.setCachedObject(this.getSystemDefaultMockStorageKey(), settings);
		}
		return JSON.parse(JSON.stringify(settings));
	}
    makeGetHttpCall(url:string , owner:any , success:any , failure:any , optionalHeader?:any , responseType?:any){

		var c = null;
		try {
			//c = jQuery("meta[name=_csrf]").attr("content");
			//c = this.getCsrfCookie( );
		} catch (error) {
			
		}
		let headers = new HttpHeaders().set('content-type', 'application/json');

		const token = this.getJwtTokenForRequest(url);
		if( token && !url.startsWith( this.contextPath ) ){
			headers = headers.set('Authorization', `Bearer ${token}`);
		}


		if( c != null ){
			//headers.append('X-CSRF-TOKEN', c); 
		}
		if( optionalHeader != null ){
			headers = optionalHeader;
		}
		var rxjs = null;
		var urlRef = url;
		var hn = this.hostName;

		if( responseType != null ){
			rxjs = this.http.get( urlRef , { 'headers' : headers , 'observe' : 'response'  , "responseType" : responseType} );
		}else {
			rxjs = this.http.get( urlRef , { 'headers' : headers , 'observe' : 'response' } );
		}


        rxjs.subscribe( (data:HttpResponse<string>) => {
			if( success ){
				let resp:any = null;
				try {
					resp = this.wrapHttpResponse(data.status, data.body, data.headers);
				} catch (e) {
					resp = data;
				}
				this.invokeOwnerCallback(success, owner, resp);
			}
				
		}, (error:any) => {

			if( error.status == 401 && this.shouldRedirectOnHttpAuthFailure(url) ){
				this.handleAuthenticationFailure();
			}
			if( failure ){
				let resp:any = null;
				try {
					resp = this.wrapHttpResponse(error.status, error.error, error.headers);
				} catch ( e ) {
					resp = error;	
				}

				this.invokeOwnerCallback(failure, owner, resp);
			}	
		});
    }

	getCookie(cookieName:string){
		var v = document.cookie;
		if( v!=null){
			var splitted  = v.split( ";" );
			for( var ctr=0; ctr<splitted.length; ctr++){
				var c = splitted[ctr].split("=");
				if( c.length > 0 && c[0].trim() == cookieName ){
					return c[1];
				}
			}
		}
		return null;
	}

    makePostHttpCall(url:any , value:any , owner:any , success:any , failure:any  , optionalHeader?:any , responseType?:any , withCredentials?:boolean ){
		var c = null;
		try {
			//c = jQuery("meta[name=_csrf]").attr("content");
			c = null;//this.getCsrfCookie( );
		} catch (error) {
			
		}
		let headers = new HttpHeaders().set('content-type', 'application/json');
		if( optionalHeader!=null ){
			headers = optionalHeader;
		}

		var rxjs:any = null;
		var options = null;
		const token = this.getJwtTokenForRequest(url);
		if( token && !url.startsWith( this.contextPath ) ){
			headers = headers.set('Authorization', `Bearer ${token}`);
		}

		if( responseType != null ){
			options = { 'headers' : headers , 'observe' : 'response'  , "responseType" : responseType};
		}
		else {
			options = { 'headers' : headers , 'observe' : 'response' };
		}
		if( withCredentials != null && withCredentials == true ){
			options["withCredentials"] = true;
			//console.info( " adding credentials : "+JSON.stringify(options) +"\t"+ url );

		}
		rxjs = this.http.post( url , value , options );


		        
        rxjs.subscribe( (data:any) => {
				if( success ){
					let resp:any = null;
					try {
						resp = this.wrapHttpResponse(data.status, data.body, data.headers);
					} catch ( e ) {
						resp = data;						
					}
					this.invokeOwnerCallback(success, owner, resp);
				}
                	
            }, (error:any) => {

                if( error.status == 401 && this.shouldRedirectOnHttpAuthFailure(url) ){
					this.handleAuthenticationFailure();
				}
				if( failure ){
					let resp:any = null;
					try {
						resp = this.wrapHttpResponse(error.status, error.error, error.headers);
					} catch (error) {
						resp = error;	
					}
	
					this.invokeOwnerCallback(failure, owner, resp);
				}
                	
            });
    }

    makePutHttpCall(url:any , value:any , owner:any , success:any , failure:any  , optionalHeader?:any , responseType?:any ){
		let headers = new HttpHeaders().set('content-type', 'application/json');
		if( optionalHeader!=null ){
			headers = optionalHeader;
		}

		const token = this.getJwtTokenForRequest(url);
		if( token && !url.startsWith( this.contextPath ) ){
			headers = headers.set('Authorization', `Bearer ${token}`);
		}

		var options:any = null;
		if( responseType != null ){
			options = { 'headers' : headers , 'observe' : 'response'  , "responseType" : responseType};
		}
		else {
			options = { 'headers' : headers , 'observe' : 'response' };
		}

		this.http.put( url , value , options ).subscribe( (data:any) => {
				if( success ){
					let resp:any = null;
					try {
						resp = this.wrapHttpResponse(data.status, data.body, data.headers);
					} catch ( e ) {
						resp = data;
					}
					this.invokeOwnerCallback(success, owner, resp);
				}
            }, (error:any) => {
                if( error.status == 401 && this.shouldRedirectOnHttpAuthFailure(url) ){
					this.handleAuthenticationFailure();
				}
				if( failure ){
					let resp:any = null;
					try {
						resp = this.wrapHttpResponse(error.status, error.error, error.headers);
					} catch (error) {
						resp = error;
					}
					this.invokeOwnerCallback(failure, owner, resp);
				}
            });
    }

	private buildOmsQueryString(params: Record<string, any>): string {
		const parts: string[] = [];
		for (const key of Object.keys(params)) {
			const val = params[key];
			if (val != null && val !== '') {
				parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
			}
		}
		return parts.length > 0 ? '?' + parts.join('&') : '';
	}

	getTeacherLeaveTypes(owner: any, success: any, failure: any): void {
		const url = this.omsContextPath + 'oms/teacher-leaves/types';
		this.makeGetHttpCall(url, owner, success, failure);
	}

	searchMyTeacherLeaves(request: any, owner: any, success: any, failure: any): void {
		const url = this.omsContextPath + 'oms/teacher-leaves/mine' + this.buildOmsQueryString(request);
		this.makeGetHttpCall(url, owner, success, failure);
	}

	getTeacherLeaveById(id: number, owner: any, success: any, failure: any): void {
		const url = this.omsContextPath + 'oms/teacher-leaves/' + id;
		this.makeGetHttpCall(url, owner, success, failure);
	}

	createTeacherLeave(request: any, owner: any, success: any, failure: any): void {
		const url = this.omsContextPath + 'oms/teacher-leaves';
		this.makePostHttpCall(url, request, owner, success, failure);
	}

	updateTeacherLeave(id: number, request: any, owner: any, success: any, failure: any): void {
		const url = this.omsContextPath + 'oms/teacher-leaves/' + id;
		this.makePutHttpCall(url, request, owner, success, failure);
	}

	cancelTeacherLeave(id: number, owner: any, success: any, failure: any): void {
		const url = this.omsContextPath + 'oms/teacher-leaves/' + id + '/cancel';
		this.makePostHttpCall(url, {}, owner, success, failure);
	}
    
	getCachedObject(key:string):any{

		//if(/localhost/.test(document.location.host)) {
			if(typeof(sessionStorage) != 'undefined') // development mode
			{
				if( sessionStorage.getItem(key) != undefined && sessionStorage.getItem(key) != null){
					return JSON.parse(sessionStorage.getItem(key));
				}
			}
			return null;
		/*}else{
			if(typeof(localStorage) != 'undefined') // development mode
			{
				if( localStorage.getItem(key) != undefined || localStorage.getItem(key) != null){
					return JSON.parse(localStorage.getItem(key));
				}
			}
			return null;
		}*/
	}

	setCachedObject(key:string, value:any):any{
		//if(/localhost/.test(document.location.host)) {
			if(typeof(sessionStorage) != 'undefined') // development mode
			{
				if( typeof(value) == 'string')
					sessionStorage.setItem(key , value);
				if( typeof(value) == 'object')
					sessionStorage.setItem(key , JSON.stringify(value));
			}
			return null;
		/*}else{
			if(typeof(localStorage) != 'undefined') // production mode
			{
				if( typeof(value) == 'string')
					localStorage.setItem(key , value);
				if( typeof(value) == 'object')
					localStorage.setItem(key , JSON.stringify(value));
			}
			return null;
		}*/
	}

	clearCacheForKey(key:string){
		if(typeof(sessionStorage) != 'undefined') // development mode
		{
			if( sessionStorage.getItem(key) != undefined && sessionStorage.getItem(key) != null){
				sessionStorage.removeItem(key);
			}
		}
	}
	
	private getLogoutRedirectUrl(): string {
		if (/localhost/.test(document.location.host)) {
			if (document.location.port === '4201') {
				return 'http://localhost:4201/';
			}
			return 'http://localhost:4200/';
		}

		const tanzeel: any = window['DATA'];
		if (tanzeel?.host != null && tanzeel.host !== '') {
			return tanzeel.host;
		}

		return '/';
	}

	logout(owner:any, logoutSuccess:any, logoutFailed:any , clearSession?:any){
		sessionStorage.removeItem("jwt_token");
		if (clearSession !== false) {
			sessionStorage.clear();
		}
		this.authUser = null;

		if (owner != null && logoutSuccess != null) {
			logoutSuccess.call(owner);
		}

		window.location.href = this.getLogoutRedirectUrl();
		void logoutFailed;
		/*
		let headers = new HttpHeaders().set(  'Content-Type' , 'application/x-www-form-urlencoded' );
    	
		var body = "";

		let logoutheaders = new HttpHeaders()
		.set(  'device-id' , '1122334455' )
		.set(  'auth-key' , md5('TANZEEL_MOBILE_APP_REGISTER_CODE_11223344_1122334455' ) );

		this.makePostHttpCall( this.tanzeel.trialContextPath+"/security/logout"  , body , this , null, null , this.getTrialCsrfHeader() );
		this.makePostHttpCall( this.tanzeel.common.logOutUrl.toString()  , body , this , (data:any)=>{
			this.authUser = null;
			if( clearSession == undefined )
				sessionStorage.clear();
			if( owner != null && logoutSuccess!= null ){
				
				logoutSuccess.call( owner );
			}
		}, (error:any)=>{
			if( owner != null && logoutFailed!= null )
				logoutFailed.call( owner );
		} , headers);*/
	}

    getGenderList( ){
		var ajax = new XMLHttpRequest();
		ajax.open("get" , this.newContextPath+"common/gender/list" , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);

		if( this.getCachedObject("getGenderList") != null) {
			return this.getCachedObject("getGenderList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			console.info(" Gender list : "+ responseText );
			var obj = JSON.parse(responseText);
			this.setCachedObject("getGenderList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

    getScholarshipAppStatusList( ){
		var ajax = new XMLHttpRequest();
		ajax.open("get" , this.newContextPath+ "common/scholarshipappstatus/list" , false);
		if( this.getCachedObject("getApplicationStatusList") != null) {
			//console.info(" Gender List is cached list ");
			return this.getCachedObject("getApplicationStatusList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getApplicationStatusList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}
	
    getSATeacherPrefList( id:any ){
		var ajax = new XMLHttpRequest();
		var url = this.tanzeel.serviceUrls.student.getSATeacherPrefList.toString();
		url = url.replace("#parentId" , id);
		ajax.open("get" , url , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			//this.setCachedObject("getSATeacherPrefList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

	getProfessionList( ){
		var ajax = new XMLHttpRequest();
		ajax.open("get" , this.newContextPath+"common/profession/list" , false);
		if( this.getCachedObject("getProfessionList") != null) {
			return this.getCachedObject("getProfessionList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getProfessionList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

	getScholarshipIntentList( ){
		var ajax = new XMLHttpRequest();
		ajax.open("get" , this.newContextPath+"common/scholarshipIntent/list" , false);
		if( this.getCachedObject("getScholarshipIntentList") != null) {
			return this.getCachedObject("getScholarshipIntentList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getScholarshipIntentList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

	getScholarshipTypeList( ){
		var ajax = new XMLHttpRequest();
		ajax.open("get" , this.newContextPath+ "common/scholarshiptype/list", false);
		if( this.getCachedObject("getScholarshipTypeList") != null) {
			return this.getCachedObject("getScholarshipTypeList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getScholarshipTypeList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

    getTimezoneList( ){
        
        var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/timeZoneArea/list" , false);

		if( this.getCachedObject("getTimezoneList") != null) {
				//console.info(" Gender List is cached list ");
				return this.getCachedObject("getTimezoneList")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getTimezoneList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }

    }

	getPrefTimeToCallList( ){
        
        var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/preftimetocall/list"  , false);

		if( this.getCachedObject("getPrefTimeToCallList") != null) {
				//console.info(" Gender List is cached list ");
				return this.getCachedObject("getPrefTimeToCallList")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getPrefTimeToCallList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }

    }
	
	getAgeGroupList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/ageGroup/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getAgeGroupList") != null) {
				//console.info(" Gender List is cached list ");
				return this.getCachedObject("getAgeGroupList")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getAgeGroupList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}
	
	getRecordingPreference(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.tanzeel.contextPath+"controller/system/recordingpreference/getrecordingpreference" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);

        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			//this.setCachedObject("getRecordingPreference" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	getSpecialityAreaList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/specialityArea/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getSpecialityAreaList") != null) {
				//console.info(" getSpecialityAreaList List is cached list ");
				return this.getCachedObject("getSpecialityAreaList")
		}
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getSpecialityAreaList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}
	
	getBestForList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/bestFor/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getBestForList") != null) {
				//console.info(" getSpecialityAreaList List is cached list ");
				return this.getCachedObject("getBestForList")
		}
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getBestForList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	getStudentStatusList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/studentStatus/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getStudentStatusList") != null) {
				//console.info(" getStudentStatusList List is cached list ");
				return this.getCachedObject("getStudentStatusList")
		}
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getStudentStatusList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

    requireStudentCardReset(studentId:any, owner:any, success:any, failure:any) {
        this.makePostHttpCall(this.newContextPath + 'students/card-recovery/require/' + studentId,
            {}, owner, success, failure);
    }

	updateStudentStatus(studentId:any, status:any, owner:any, success:any, failure:any){
		const url = this.newContextPath+"students/student/student/update/"+studentId+"/status";
		this.makePostHttpCall(url, status, owner, success, failure);
	}

	clearCourseListCache(){
		this.clearCacheForKey( "course.getCoursesList" );
	}


	loginNEW(userdata: any , owner:any , loginSuccess:any , loginFailure:any) {
		// Resolve from the origin so a trailing slash in any runtime base URL cannot
		// produce a `//api/...` request, which ASP.NET Core will not route.
		const url = /localhost/.test(document.location.host)
			? this.newContextPath + "common/auth/login"
			: new URL('/api/common/auth/login', window.location.origin).toString();
		const body = {"email" : userdata['email'], "password":userdata['password'] } ;
		console.info('[loginNEW] POST', url, body);
		this.makePostHttpCall( url , body , owner , loginSuccess, loginFailure );
	}
	paymentPlans:any = null;
	searchPaymentPlans(sc:any , owner:any , success:any , failure:any){

		var searchPageCriteria = {};
		
		searchPageCriteria["pageCriteria"] = {currentPage : 1};
		searchPageCriteria["searchCriteria"]=[];
		var newSC = sc;
		if( sc == null || sc == undefined )
			newSC = searchPageCriteria;
		if( newSC["searchCriteria"] == undefined || newSC["searchCriteria"] == null )
			newSC["searchCriteria"]=[];
		
		var filtersList:any = [];
		for( var i = 0 ; i < searchPageCriteria["searchCriteria"].length ; i++ ){
			var spcItem = searchPageCriteria["searchCriteria"][i];
			var filterItem = {"property" : spcItem['fieldName'] , "value1" : spcItem['value1'], "value" : spcItem['value'] , "dataType" : this.getSearchCriteriaDataType(spcItem['dataType']) , "condition" : this.getSearchCriteriaCondType(spcItem['condType']) , "operation" : this.getSearchCriteriaCompareType(spcItem['compareType'])   };
			filtersList.push( filterItem );
		}

		var filterRequest = {
			"filters" : filtersList,
			"pageSize" : 5,
			"pageNumber" : searchPageCriteria["pageCriteria"].currentPage,
			"sortBy" : "id",
		};
		var url = this.newContextPath+"common/search/paymentplans"
		this.makePostHttpCall( url , newSC , owner , success,  failure ); 
        
	}

	updateStudentPaymentPlan( studentId:any , paymentPlan:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/student/update/paymentplan/"+studentId+"/"+paymentPlan;
		this.makePostHttpCall( url , "" , owner , success,  failure );     
	}

	getTeachersAvailableMultiScheduleForTrialStudent(studentId:any , owner:any , success:any , failure:any , timezoneCode?:string , duration?:number ){
		
		let headers = new HttpHeaders().set( 'Content-Type', 'application/json' );
        let options = { headers: headers };
		
		var str = this.tanzeel.trialContextPath+"/rest/student/student/availableSlots/#studentId/#slotsType/#durationMts/#tzaCode";
		str = str.replace("#studentId", studentId);
		if( timezoneCode == undefined || timezoneCode == null || timezoneCode == ''){
			str = str.replace('#slotsType','multiple').replace('#tzaCode','000');
		}
		else {
			str = str.replace('#slotsType','multiple').replace('#tzaCode',timezoneCode);
		}
		if( duration != null )
			str = str.replace('#durationMts', (''+duration) );
		else 
			str = str.replace('#durationMts', '30' );

		//console.info( this.tanzeel.serviceUrls.student.getAvailableTimeSlots.toString()+" getTeachersAvailableMultiScheduleForStudent : "+ str );
		this.makeGetHttpCall( str , owner , success , failure );
		
	}

	saveStudentMultipleScheduleTrial(data:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/enrollment/slotsselect/beforereview";
		this.makePostHttpCall( url , data , owner , success , failure, this.getTrialCsrfHeader() );
	}

	saveANewLanguage( lng:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"common/save/newlanguage"
		this.makePostHttpCall( url , lng , owner , success , failure);
	}

	completePaymentTrialReviewed( data:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/enrollment/reviewcomplete";
		this.makePostHttpCall( url , data , owner , success , failure, this.getTrialCsrfHeader() );
	}

	getCourseListFromController( courseData: any , owner:any , success:any , failure:any ){
		var filterRequest = this.toFilterRequestVO( courseData.searchCriteria , courseData.pageCriteria==null?{}: courseData.pageCriteria);

		var url = this.newContextPath+"course/course/searchcourselistscreen";
		this.makePostHttpCall( url , filterRequest , this , (data:any)=>{
				var json = data.json();
				var _pages = Math.ceil(json.totalCount / json.pageSize);
				var pageCriteria = { totalPages : _pages , currentPage : json.pageNumber , totalHits : json.totalCount , maxRowsPerPage : filterRequest.pageSize };
				var sr = {
					"data" : json.items,
					"pageCriteria" : pageCriteria
				}
				var ref = {
					json : ()=>{ return sr; }
				}
				if( success)	success.call( owner , ref );
		} , (data:any)=>{
			if( failure )	failure.call( owner , data );
		});
	}
	
	deletePaymentPlan( planId: any , owner:any , success:any , failure:any ){
		var url = this.contextPath+"controller/billing/paymentplan/delete/"+planId;
		this.makePostHttpCall( url , {} , owner , success , failure);
	}

	getCoursesList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"course/course/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        if( this.getCachedObject("course.getCoursesList") != null) {
				//console.info(" getCoursesTypesList List is cached list ");
				return this.getCachedObject("course.getCoursesList");
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("course.getCoursesList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	getTeachersRegionList(){
		if( this.getCachedObject("teacher.getTeachersRegionList") != null) {
			return this.getCachedObject("teacher.getTeachersRegionList");
		}
		var ajax = new XMLHttpRequest();
		var url = this.tanzeel.serviceUrls.teacher.getTeacherRegionList.toString();
		ajax.open("get" , url , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("teacher.getTeachersRegionList" , obj);
			return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}
	getScheduleTypesList(){
		if( this.getCachedObject("getScheduleTypesList") != null) {
				//console.info(" getSpecialityAreaList List is cached list ");
				return this.getCachedObject("getScheduleTypesList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/scheduletype/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getScheduleTypesList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}
	
	getRepeatFrequencyList(){
		if( this.getCachedObject("getRepeatFrequencyList") != null) {
				//console.info(" getRepeatFrequencyList List is cached list ");
				return this.getCachedObject("getRepeatFrequencyList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/repeatFrequency/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getRepeatFrequencyList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}
	
	getLanguagesList(refresh?:boolean){
		if( this.getCachedObject("getLanguagesList") != null && (refresh == undefined || refresh==false) ) {
				//console.info(" getLanguagesList List is cached list ");
				return this.getCachedObject("getLanguagesList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/all/language/list", false );
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getLanguagesList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	getCourseEnrollmentStatusList(refresh?:boolean){

		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/courseenrollmentstatus/list", false );
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			//this.setCachedObject("getLanguagesList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

/*
	private googleAuth:any;
    private gapi:any = null;
	
	private initializeGoogleApi(){
			this.gapi = window["gapi"];
			var ref = this.gapi.load('client:auth2', ()=>{ this.gapi.client.init({
					discoveryDocs: this.tanzeel.GAPI_DISCOVERY_DOCS,
					clientId: this.tanzeel.GAPI_CLIENT_ID.toString(),
					scope: this.tanzeel.GAPI_SCOPES.toString()
			}).then(()=> {
						 this.googleAuth = this.gapi.auth2.getAuthInstance();	
						 this.googleSignIn();
		
				}, ()=>{
						// show error message to user as initialization failed, this shud not happen usually
						console.info(" this.gapi.load failure onError called  " ); 
					});
			});
			
	}

	public googleSignIn(){
		if( this.googleAuth != null && this.googleAuth != undefined ){
			try{
				this.googleAuth.signIn();
			}catch(e){
				console.info( " singin error :"+  e );
			}
		}
		else {
				this.initializeGoogleApi();
		}
	}
	
	public isGoogleAuthSignedIn():boolean{
		if( this.googleAuth != null && this.googleAuth != undefined ){
			return this.googleAuth.isSignedIn.get();
		}
		else {
			return false;
		}
	}
	*/
	colorCodes:any[] = [

		{
			"displayName" 	: "Violet",
			"value"	: "#EE82EE"
		},
		{
			"displayName" 	: "Indigo",
			"value"	: "#4B0082"
		},
		{
			"displayName" 	: "Blue",
			"value"	: "#0000FF"
		},
		{
			"displayName" 	: "Green",
			"value"	: "#008000"
		},
		{
			"displayName" 	: "Yellow",
			"value"	: "#FFFF00"
		},
		{
			"displayName" 	: "Orange",
			"value"	: "#FFA500"
		},
		{
			"displayName" 	: "Red",
			"value"	: "#FF0000"
		}
		
	]
	getScheduleColorCodes(){
		return this.colorCodes;
	}
	
	getDonationAmountList(){
		if( this.getCachedObject("getDonationAmountList") != null) {
				//console.info(" getDonationAmountList List is cached list ");
				return this.getCachedObject("getDonationAmountList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.tanzeel.serviceUrls.common.getDonationTypeList.toString() , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getDonationAmountList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }		
	}
	
	getDonationRecurringList(){
		if( this.getCachedObject("getDonationRecurringList") != null) {
				//console.info(" getDonationRecurringList List is cached list ");
				return this.getCachedObject("getDonationRecurringList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/donationRecurring/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getDonationRecurringList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}
	
	getDonationOneTimeList(){
		if( this.getCachedObject("getDonationOneTimeList") != null) {
				//console.info(" getDonationOneTimeList List is cached list ");
				return this.getCachedObject("getDonationOneTimeList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/donationOneTime/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getDonationOneTimeList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }		
	}
	
	getProductList(){
		if( this.getCachedObject("getProductList") != null) {
				//console.info(" getProductList List is cached list ");
				return this.getCachedObject("getProductList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.tanzeel.serviceUrls.course.getProductList.toString() , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getProductList" , obj);
            return obj;
        } catch (e) {
            console.info( e );
            return [];
        }		
	}
	

	getPlanTypeList(){
		if( this.getCachedObject("getPlanTypeList") != null) {
				//console.info(" getPlanTypeList List is cached list ");
				return this.getCachedObject("getPlanTypeList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.tanzeel.serviceUrls.common.getPlanTypeList.toString() , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getPlanTypeList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }		
	}

	getRatingCodeList(){
		if( this.getCachedObject("getRatingCodeList") != null) {
				return this.getCachedObject("getRatingCodeList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/ratingcode/list", false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getRatingCodeList" , obj);
            return obj;
        } catch (e) {
            console.info( e );
            return [];
        }		
	}

	
	getConvertedFormattedTime(value:string , fromTimeZone:string , toTimeZone:string , twentyFourHourFormat?:boolean):string{
        //console.info("+selectedTimezone.code : "+ this.selectedTimezone.code);
        var omoment = moment(value+" "+fromTimeZone , 'HH:mm Z');
        var odate = omoment.date();
        var modMoment = omoment.utcOffset(toTimeZone);

        var vardate = modMoment.date();
        //console.info( " omoment.date() : "+odate+" , modMoment.date() : "+vardate+" , diff : "+(odate-vardate));
        var diff = (vardate - odate);
        var str  = modMoment.format('hh:mm A');
        if( diff > 0)
            str = str + ' (+'+diff+'d)';
        else if( diff < 0)
            str = str + ' ('+diff+'d)';
        //console.info(str+' time : '+value+' , localTimeZone : '+fromTimeZone+' , targetTimezone : '+toTimeZone);
        return str.startsWith('0')?str.substring(1 , str.length ): str;
    }

	count:number  = 0;
	getConvertedFormattedTimeV2(value:string , fromTimeZone:string , toTimeZone:string , timezone:any):string{
        //console.info("+selectedTimezone.code : "+ this.selectedTimezone.code);
        var omoment = moment(value, 'HH:mm Z');
        var odate = omoment.date();
        var modMoment = omoment.tz(timezone.timeZone);
		
		
        var vardate = modMoment.date();
        //console.info( " omoment.date() : "+odate+" , modMoment.date() : "+vardate+" , diff : "+(odate-vardate));
        var diff = null;
        var str  = modMoment.format('hh:mm A');
		if(omoment.tz != undefined){
				var mom = omoment.tz(timezone.timeZone);

				if( mom.isDST() )
				{
					str  = mom.format('hh:mm A');
				}
				//console.info("from: "+fromTimeZone+" , to:"+toTimeZone+" , .timeZone : "+timezone.timeZone+" , o : "+omoment.format('hh:mm Z A')+" , m : "+mom.format('hh:mm Z A')+", dst:"+mom.isDST()+", str :"+str);
				diff = mom.diff( omoment , "days" );
		}else{
			console.info(" !omoment.tz : ");
		}
        
        if(diff!=null && diff > 0)
            str = str + ' (+'+diff+'d)';
        else if( diff!=null && diff < 0)
            str = str + ' ('+diff+'d)';
        //console.info(str+' time : '+value+' , localTimeZone : '+fromTimeZone+' , targetTimezone : '+toTimeZone);
        str = str.startsWith('0')?str.substring(1 , str.length ): str;
		return str;
    }
	
	getConvertedFormattedTimeV3(value:string , fromTimeZone:any , timezone:any):string{
		moment.tz.setDefault(fromTimeZone);
        var omoment = moment(value, 'HH:mm Z');
        var odate = omoment.date();
        var modMoment = omoment.clone().tz(timezone.timeZone);
		this.count++;
		
		
        var vardate = modMoment.date();
        var diff = null;
        var str  = modMoment.format('hh:mm A');
		if(omoment.tz != undefined){
				var mom = omoment.tz(timezone.timeZone);

				if( mom.isDST() )
				{
					str  = mom.format('hh:mm A');
				}
				diff = mom.diff( omoment , "days" );
		}else{
			console.info(" !omoment.tz : ");
		}
        
        if(diff!=null && diff > 0)
            str = str + ' (+'+diff+'d)';
        else if( diff!=null && diff < 0)
            str = str + ' ('+diff+'d)';
        str = str.startsWith('0')?str.substring(1 , str.length ): str;
		moment.tz.setDefault();
		return omoment.format('hh:mm A');
		/*
		moment.tz.setDefault(fromTimeZone);
        var omoment = moment(value, 'HH:mm Z');
        var odate = omoment.date();
        var modMoment = omoment.clone().tz(timezone.timeZone);
		this.count++;
		
		
        var vardate = modMoment.date();
        //console.info( " omoment.date() : "+odate+" , modMoment.date() : "+vardate+" , diff : "+(odate-vardate));
        var diff = null;
        var str  = modMoment.format('hh:mm A');
		if(omoment.tz != undefined){
				var mom = omoment.tz(timezone.timeZone);

				if( mom.isDST() )
				{
					str  = mom.format('hh:mm A');
				}
				//console.info("from: "+fromTimeZone+" , to:"+toTimeZone+" , .timeZone : "+timezone.timeZone+" , o : "+omoment.format('hh:mm Z A')+" , m : "+mom.format('hh:mm Z A')+", dst:"+mom.isDST()+", str :"+str);
				diff = mom.diff( omoment , "days" );
		}else{
			console.info(" !omoment.tz : ");
		}
        
        if(diff!=null && diff > 0)
            str = str + ' (+'+diff+'d)';
        else if( diff!=null && diff < 0)
            str = str + ' ('+diff+'d)';
        //console.info(str+' time : '+value+' , localTimeZone : '+fromTimeZone+' , targetTimezone : '+toTimeZone);
        str = str.startsWith('0')?str.substring(1 , str.length ): str;
		moment.tz.setDefault();
		return omoment.format('hh:mm A');*/
    }

	saveTeacherSchedule(sendData:any , owner:any , success:any , failure:any , partUrl:string ){
		var url = this.newContextPath+"teachers/schedule/save"+partUrl;
        this.makePostHttpCall( url , sendData , owner , success, failure);
	}

	addTimesTeacherAvailability(sendData:any , owner:any , success:any , failure:any  ){
		var url = this.newContextPath+"teachers/save/teacheravailability/new";
        this.makePostHttpCall( url , sendData , owner , success, failure);
	}

	deleteTimesTeacherAvailability(sendData:any , owner:any , success:any , failure:any  ){
		var url = this.newContextPath+"teachers/delete/teacheravailability/new";
        this.makePostHttpCall( url , sendData , owner , success, failure);
	}

	createTeacherAvailabilityDeleteRequest(sendData:any , owner:any , success:any , failure:any  ){
		var url = this.newContextPath+"teachers/availability/delete-request";
        this.makePostHttpCall( url , sendData , owner , success, failure);
	}

	searchTeacherAvailabilityDeleteRequests(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"teachers/availability/delete-requests";
		var params:string[] = [];
		if (request != null) {
			if (request.status != null && request.status !== '') {
				params.push('status=' + encodeURIComponent(request.status));
			}
			if (request.teacherId != null && request.teacherId !== '' && request.teacherId > 0) {
				params.push('teacherId=' + encodeURIComponent(request.teacherId));
			}
			if (request.pageNumber != null) {
				params.push('pageNumber=' + encodeURIComponent(request.pageNumber));
			}
			if (request.pageSize != null) {
				params.push('pageSize=' + encodeURIComponent(request.pageSize));
			}
		}
		if (params.length > 0) {
			url += '?' + params.join('&');
		}
        this.makeGetHttpCall( url , owner , success, failure);
	}

	approveTeacherAvailabilityDeleteRequest(requestId:any , owner:any , success:any , failure:any  ){
		var url = this.newContextPath+"teachers/availability/delete-request/"+encodeURIComponent(requestId)+"/approve";
        this.makePostHttpCall( url , {} , owner , success, failure);
	}

	rejectTeacherAvailabilityDeleteRequest(requestId:any , sendData:any , owner:any , success:any , failure:any  ){
		var url = this.newContextPath+"teachers/availability/delete-request/"+encodeURIComponent(requestId)+"/reject";
        this.makePostHttpCall( url , sendData || {} , owner , success, failure);
	}

	GetTimesTeacherAvailability(teacherId:any , owner:any , success:any , failure:any  ){
		var url = this.newContextPath+"teachers/get/teacheravailability/new/"+teacherId;
        this.makeGetHttpCall( url , owner , success, failure);
	}

	searchTeacherAvailabilityHistory(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"teachers/search/teacheravailabilityhistory";
		this.makePostHttpCall( url , request , owner , success , failure );
	}

	updateTeacherSchedule(sendData:any , owner:any , success:any , failure:any , partUrl:string ){
		var url = this.newContextPath+"teachers/schedule/update"+partUrl;
        this.makePostHttpCall( url , sendData , owner , success, failure);
	}

	deleteTeacherSchedule(sendData:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"teachers/schedule/delete";
        this.makePostHttpCall( url , sendData , owner , success, failure);
	}

	getUserNotifications(owner:any , success:any , failure:any){        
        var url = this.newContextPath+"common/view/userNotifications";
        this.makeGetHttpCall( url , owner , success, failure);
    }
	
	saveUserNotificationsAsViewed(owner:any , success:any , failure:any){
        var url = this.newContextPath+"common/updateUserNotificationAsViewed/userNotifications";
        this.makeGetHttpCall( url , owner , success, failure);
    }

	getStudentCoursesByKey( studentId:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/student/studentcourseappointment/list/"+ studentId;
        this.makeGetHttpCall( url , owner , success, failure);
	}

	adminRestoreStudentCourse(scId:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/student/restore/studentcourse/"+scId;
        this.makePostHttpCall( url , {}, owner , success, failure);
	}

	adminDeleteStudentCourse(scId:any , reason:string , owner:any , success:any , failure:any){
        var url = this.contextPath+"controller/student/delete/studentcourse/"+scId+"/"+reason;
        this.makePostHttpCall( url , {}, owner , success, failure);
	}

	adminDeleteTrialClassesForStudent( studentId:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/student/"+studentId+"/trial/futureappointments/delete" ;
        this.makePostHttpCall( url , {}, owner , success, failure);
	}

	adminViewStudentCourse(scId:any , owner:any , success:any , failure:any){
        var url = this.contextPath+"controller/student/view/studentcourse/"+scId;
        this.makeGetHttpCall( url , owner , success, failure);
	}

	getStudentEnrolledCourses( studentid:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"course/student/coursecomponent/list/"+studentid;
        this.makeGetHttpCall( url , owner , success, failure);
	}

    getClassNotesTeacherCourses(teacherId:number, owner:any, success:any, failure:any) {
        this.makeGetHttpCall(this.newContextPath + 'notes/teacherCourseComponent/list/' + teacherId, owner, success, failure);
    }

    getClassNotesStudentCourses(studentId:number, owner:any, success:any, failure:any) {
        this.makeGetHttpCall(this.newContextPath + 'notes/student/' + studentId + '/components', owner, success, failure);
    }

    saveReviewedClassNotes(notes:any, owner:any, success:any, failure:any) {
        this.makePostHttpCall(this.newContextPath + 'notes/teachernotes/save-reviewed', notes, owner, success, failure);
    }

    getClassNotesHistory(request:any, owner:any, success:any, failure:any) {
        this.makePostHttpCall(this.newContextPath + 'notes/history', request, owner, success, failure);
    }

    getClassNotesMeeting(meetingId:number, owner:any, success:any, failure:any) {
        this.makeGetHttpCall(this.newContextPath + 'notes/meeting/' + meetingId + '/context', owner, success, failure);
    }

	getTeacherNotesForMeeting( meetingid:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"notes/teachernotes/meeting/"+meetingid+"?randomdUINumber="+(Math.random()*100000);
        this.makeGetHttpCall( url , owner , success, failure);
	}

	saveTeacherClassNotes( notes:any , owner:any , success:any , failure:any){		
		var url = this.newContextPath+"notes/teachernotes/save";
        this.makePostHttpCall( url , notes , owner , success, failure , null , "text");
	}

	getStudentsEnrolledInPastSevenDays( student:any , owner:any , success:any , failure:any){		
		var url = this.newContextPath+"students/student/enrolled/monthwise";
        this.makePostHttpCall( url , student , owner , success, failure);
	}

	getTrialStudentsNeverEnrolled( date:any , selectedFilter:any , downloadCSV:boolean , owner:any , success:any , failure:any){		
		var url = this.newContextPath+"students/view/trialstudents/neverenrolled/"+date+"/"+selectedFilter+"/"+downloadCSV;
        this.makeGetHttpCall( url , owner , success, failure);
	}

	searchSupportCriteriaCustom( spc:any , owner:any , success:any , failure:any){		
		var url = this.newContextPath+"system/search/supportticket/custom";
        this.makePostHttpCall( url , spc , owner , success, failure);
	}

	saveRecordingPreference( pref:any , owner:any , success:any , failure:any){
		var url = this.contextPath+"rest/system/recordingpreference/save";
        this.makePostHttpCall( url , pref, owner , success, failure);
	}
	
	updateSpecAreaStudentCourse( specAreaCode:any , studentCourseId:any , action:any , owner:any , success:any , failure:any){
		var url = this.contextPath+"controller/student/studentcourse/updateStudentcourseSpecArea/"+specAreaCode+"/"+studentCourseId+"/"+action;
		var temp = {};
        this.makePostHttpCall( url , temp , owner , success, failure);
    }

	getAllCourseComponents(courseId:any, owner:any , success:any , failure:any){
		var url = this.newContextPath+"notes/courseComponent/list/"+courseId+"?randomdUINumber="+(Math.random()*100000);
		var sc = {
			searchCriteria : [],
			pageCriteria : {
				maxRowsPerPage : 9999
			}
		};
        this.makePostHttpCall( url , sc , owner , success, failure );
    }

	updateCourseEnrollment( scc:any ,  owner:any , success:any , failure:any){
		var url = this.newContextPath+"notes/studentcoursecomponent/update";
        this.makePostHttpCall( url , scc , owner , success, failure ,  this.getTrialCsrfHeader() );
    }

	authUser:any = null;
    private handleCardRecoveryResponse(status: number, text: string): boolean {
        if (status !== 403) return false;
        try {
            const body = JSON.parse(text);
            if (body.code === 'CARD_RECOVERY_REQUIRED') {
                window.location.replace('/#/student/r/billing/updateCard');
                return true;
            }
            if (body.code === 'STUDENT_ACCOUNT_DISABLED') {
                sessionStorage.removeItem('jwt_token');
                window.location.replace('/#/boarding/loginUser?cardRecoveryDisabled=1');
                return true;
            }
        } catch { /* Existing authentication handling applies to other responses. */ }
        return false;
    }

	getLoggedInAuthUser(navigateHome?:boolean, redirectOnAuthFailure:boolean = true){
		var jwt = this.getValidJwtToken(redirectOnAuthFailure === false);
		// Menu checks can run after logout clears the session, before the page unloads.
		if (jwt == null || jwt === '') {
			this.authUser = null;
			if (redirectOnAuthFailure) {
				this.handleAuthenticationFailure();
			}
			return null;
		}

		if( this.authUser!=null )
			return this.authUser;
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/authuser/by/userid" , false);
        ajax.setRequestHeader("Content-Type", "application/json");
		if( jwt != null && jwt !== '' ){
			ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		}
        try {
            ajax.send( );
            var responseText = ajax.responseText;
            if (this.handleCardRecoveryResponse(ajax.status, responseText)) return null;
			if(ajax.status ===200 ){
				var obj = JSON.parse(responseText);
				this.authUser = obj;
				return obj;
			}
			else if( ajax.status == 401 || ajax.status == 403 ){
				if( redirectOnAuthFailure ){
					this.handleAuthenticationFailure();
				}
				return null;
			}
			else if(navigateHome != undefined && navigateHome==true &&  ajax.status == 403 ){
				//window.location.href=this.contextPath+"?signUpErrorMessage=Please Login to Continue";
			}
			else{
				return null;
			}
        } catch (e) {
            console.info( e );
            return null;
        }
	}

	getScheduleCMSTreeData(owner:any , success:any , failure:any){
		
		var url = this.tanzeel.system.searchCMSList.toString();
		var sc = {
			searchCriteria : [],
			pageCriteria : {
				maxRowsPerPage : 9999
			}
		};

		this.makePostHttpCall( url , sc , owner , success , failure);
	}
	
	searchRecordingStudentSelectionPref( searchPageCriteria:any  , owner:any , success:any , failure:any ){
        
        try{
            var url = this.contextPath+"/controller/system/search/searchrecordingstudentpreference"
            this.makePostHttpCall( url , searchPageCriteria , owner , success , failure);
        }catch(e){
            failure.call( owner , {"message": e} );
            console.info( e )
        }
	}
	
	getCMSVisibilityList(){
		if( this.getCachedObject("getCMSVisibilityList") != null) {
				console.info(" getSpecialityAreaList List is cached list ");
				return this.getCachedObject("getCMSVisibilityList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.tanzeel.serviceUrls.common.getCMSVisibilityList.toString() , false);
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getCMSVisibilityList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	scrollToTop(){
		window.scrollTo(10, 10);
	}

	getCourseRefWithId( courseId: any , addlOption:any ){
        var ajax = new XMLHttpRequest();
        var url = this.newContextPath+"course/getcourse/"+courseId;

        ajax.open("get" , url , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        try{
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}
	
	getCMSDataByID(value:any , owner:any , success:any , failure:any ){

        var url = this.newContextPath+"course/cms/viewcmsdata/"+value;
        this.makeGetHttpCall( url , owner , success, failure);
	}
	
	/*markStudentReadFlagAsTrue(studentId:any , lesson:any , owner:any, success:any, failed:any){
		
		let headers = new Headers({ 'Content-Type': 'application/json' });
		let options = new RequestOptions({ headers: headers });
		var sc = new StudentCurriculum();
		sc.cmsId = lesson.id;
		sc.readFlag = true;
		sc.studentId = studentId;
		
        var url = this.tanzeel.serviceUrls.student.saveStudentCurriculum.toString();
		this.makePostHttpCall( url , sc , owner , success , failed);
	}*/

	resetStudentProfilePassword( authUser:any , owner:any, success:any, failed:any){
		var url = this.newContextPath +"common/staff/resetPassword";
        this.makePostHttpCall( url , authUser , owner , success , failed);
	}

	resetStudentProfilePasswordByStudent( authUser:any , owner:any, success:any, failed:any){
		var url = this.newContextPath +"common/student/resetProfilePassword";
        this.makePostHttpCall( url , authUser , owner , success , failed);
	}
	
	updateStudentUserId( authUser:any , owner:any, success:any, failed:any){
		var url = this.tanzeel.contextPath+"/controller/common/update/updateStudentUserId";
        this.makePostHttpCall( url , authUser , owner , success , failed);
    }

	adjustStudentOutstandingBalance( studentInfo:any  , owner:any, success:any, failed:any){
		var url = this.newContextPath+"students/student/update/adjustoutstandingbalance";
        this.makePostHttpCall( url , studentInfo , owner , success , failed);
	}
	
	adjustStudentCredits( studentInfo:any  , owner:any, success:any, failed:any){
		var url = this.newContextPath+"students/student/saveupdate/studentcredit";
        this.makePostHttpCall( url , studentInfo , owner , success , failed);
    }

	getCommunicateTypeList(){
		if( this.getCachedObject("getCommunicateTypeList") != null) {
				//console.info(" getProductList List is cached list ");
				return this.getCachedObject("getCommunicateTypeList");
		}
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/communicateType/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getCommunicateTypeList" , obj);
            return obj;
        } catch (e) {
            console.info( e );
            return [];
        }		
	}

	getSuggestedPicturesForStudent(owner:any , success:any , failure:any ){

        var url = this.newContextPath+"common/suggestpictures/list";
        this.makeGetHttpCall( url , owner , success, failure);
	}

	searchForResources(sc: any , owner:any , success:any , failure:any ){
        
        var url = this.tanzeel.system.searchResourceListScreen.toString();
        this.makePostHttpCall( url , sc , owner , success , failure);	
    }

	saveDSTSettings( dstSetting: any , owner:any , success:any , failure:any ){
        var url = this.tanzeel.serviceUrls.system.saveDSTSetting.toString();
        this.makePostHttpCall( url , dstSetting , owner , success , failure);
	}

	deleteDSTSettings( dstSetting: any , owner:any , success:any , failure:any ){
        var url = this.tanzeel.serviceUrls.system.deleteDSTSetting.toString()

        this.makePostHttpCall( url , dstSetting , owner , success , failure);
	}

	deleteAllRecordingStudentPref(  owner:any , success:any , failure:any ){
        var url = this.contextPath+"controller/system/deleteall/recordingprefstudent";
        this.makePostHttpCall( url , null , owner , success , failure);
	}

	deleteRecordingStudentPrefList( pref: any , owner:any , success:any , failure:any ){
        var url = this.contextPath+"controller/system/system/saveList";
        this.makePostHttpCall( url , pref , owner , success , failure);
	}

	listDSTSettings( sc: any , owner:any , success:any , failure:any ){
        
        this.makePostHttpCall( this.tanzeel.system.searchDSTListScreen.toString() , sc , owner , success , failure);
	}

	notifyDstSettingForTimeZone(val:any , owner:any , success:any , failure:any){

		var url = this.tanzeel.system.notifyDSTListScren.toString();
        this.makePostHttpCall( url , val , owner , success , failure);
	}
	
	refreshDstSettingForTimeZone(timezone:any , owner:any , success:any , failure:any){

		var url = this.tanzeel.system.refreshDSTListScren.toString();
		url = url.replace("#tzaCode" , timezone);
        this.makeGetHttpCall( url , owner , success, failure);
	}
	
	getRegionTypesList( owner:any , success:any , failure:any){

		if( this.getCachedObject("getRegionTypesList") != null) {
			success.call( owner , JSON.parse( this.getCachedObject("getRegionTypesList") ) );
			return;
		}
        
		var url = this.tanzeel.serviceUrls.common.getRegionTypeList.toString();

        var rxjs = this.http.get( url );
        
        rxjs.subscribe( (data:any) => {
				this.setCachedObject("getRegionTypesList" , JSON.stringify(data) );
                success.call( owner , data );
            }, error => {
				if( error.status == 403){
					window.location.href=this.contextPath;
				}
                failure.call( owner , error );
            });
	}
	
	getRegionsForRegionType( regionType:any , owner:any , success:any , failure:any){

		var url = this.tanzeel.serviceUrls.common.getRegionCountryListByRegion.toString();
		url = url.replace( "#regionType" , regionType.code );

        this.makeGetHttpCall( url , this , (data)=>{
			success.call( owner , regionType , data );
		}, failure);
	}
	
	getUnMappedRegions( owner:any , success:any , failure:any){

		var url = this.tanzeel.serviceUrls.common.getRegionCountryList.toString();

        this.makeGetHttpCall( url , owner , success, failure);	
	}

	getDependentConsentsByParentId( id:any  , owner:any , success:any , failure:any){

		var url = this.contextPath+"controller/student/view/studentconsentsbyparentId/"+id;
        this.makeGetHttpCall( url , owner , success, failure);	
	}

	saveRegionTypeSettings( lswrapper: any , owner:any , success:any , failure:any ){
        
        var url = this.tanzeel.common.saveList.toString();
        this.makePostHttpCall( url , lswrapper , owner , success , failure);
	}
	
	saveRecordingPrefStudentList( lswrapper: any , owner:any , success:any , failure:any ){
        
        var url = this.tanzeel.system.saveList.toString();
        this.makePostHttpCall( url , lswrapper , owner , success , failure);
	}

	getUnmappedRegionTypeTimezoneList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.tanzeel.common.getUnmappedTimeZones.toString() , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }		
	}

	getStudentById(studentId:number){

		var ajax = new XMLHttpRequest();
		//var url = this.newContextPath+this.tanzeel.student.viewStudentProfileScreen.toString().replace("{id}" ,(""+studentId) );
		var url = this.newContextPath+"students/get-loggedin-student/"+studentId ;

		ajax.open("get" , url , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
             return obj;
        } catch (e) {
            return null;
        }
	}

	searchUserRoles( sc:any , owner:any , success:any , failure:any){	
		var url = this.tanzeel.serviceUrls.common.getUserRoleList.toString();
        this.makeGetHttpCall( url , owner , success, failure);	
    }

	searchStaffAuthUsers( sc:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"system/exec/searchUserSearchScreen"
        this.makePostHttpCall( url , sc , owner , success , failure);
	}


	getAllUserRoles( ){
        
        var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/userRole/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);

		if( this.getCachedObject("getAllUserRolesApi") != null) {
				return this.getCachedObject("getAllUserRolesApi")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getAllUserRolesApi" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }

    }

	saveStaffUser( sc:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"system/save/staffuser";
        this.makePostHttpCall( url , sc , owner , success , failure);
	}

	getStaffUserById( id:number , owner:any , success:any , failure:any){
		var url = this.newContextPath+"system/staffuser/"+id;
		this.makeGetHttpCall( url , owner , success , failure);
	}

	searchSystemFunction( sc:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"system/search/systemfunlistscreen";
        this.makePostHttpCall( url , sc , owner , success , failure);
    };

    searchUserPermissions( staffUserId:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"system/userpermissions/staff/"+staffUserId;
        this.makeGetHttpCall( url , owner , success , failure);
    }
 
    saveUserPermissions( staffUserId:any , permissions:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"system/userpermissions/staff/"+staffUserId;
        this.makePostHttpCall( url , permissions , owner , success , failure);
	}

	/*hasAuthority( systemFunction:string , owner:any, failure:any ):boolean{
		var ajax = new XMLHttpRequest();
		var url = this.tanzeel.serviceUrls.system.isUserHasPermission.toString().replace( "#function" , systemFunction);
        ajax.open("get" , url , false);
        
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var resp = JSON.parse( responseText );
            if( resp != undefined && (resp == true || resp == 'true'))
                return resp.message;
        } catch (e) {
            console.info( e );
        }
        var msg = {
            json : function(){
                return {
                    details : systemFunction + " Access Denied",
                    message : systemFunction + " Access Denied"
                }
            }
        }
        failure.call( owner , msg);
		return false;
	}*/

	getStaffUser( userId:string , owner:any ,  success:any , failure:any){
		var sendData = [{ 'fieldName':'authUser.userId' , 'fieldValue' : userId}];

		var url = this.tanzeel.serviceUrls.system.getStaffUserByKey.toString();
		this.makePostHttpCall( url , sendData , owner , success , failure);
	}

	_userPermissions:any = null;

	get userPermission():any{
		return this._userPermissions;
	}

	getUserAllPermissions(){
		var url = this.newContextPath+"system/userpermissions/loggedin/list";
		url = url +"?randomdUINumber="+(Math.random()*100000);
        var rxjs = this.makeGetHttpCall( url ,  this , (data:any) => {
			 this._userPermissions = data.json();
			 if( sessionStorage ){
				sessionStorage.setItem( "user.permissions.list" , JSON.stringify( this._userPermissions ) );
			 }
		} , (failure:any)=> {
			console.info(" could not retrieve user permissions ");
		});
	}

	hasAuthority( fun:string ):boolean {
		
		var upers = sessionStorage.getItem( "user.permissions.list" );
		if( this._userPermissions != null && this._userPermissions[fun]!= undefined ){
			return this._userPermissions[fun];
		}else if( this._userPermissions == null && upers != null ){
			var permissions:any = JSON.parse( upers );
			return permissions[fun];
		}else {
			return false;
		}
	}

	isSystemFunctionAllowed(sysfunc:string){
		if(this.tanzeel.secureUser != null && this.tanzeel.secureUser.role !=null && this.tanzeel.secureUser.role.toLowerCase()=="admin"){
			return true;
		}
		return this.hasAuthority( sysfunc );
	}
	/*getLoggedInTeacher( owner:any , success:any , failure:any){
		var url = this.tanzeel.teacher.viewTeacherDetailScreen.toString().replace("{id}",""+0);
		this.makeGetHttpCall( url , owner , success , failure );
	}*/

	getLoggedInTeacher( owner:any , success:any , failure:any, teacherId?:any ){
		if( teacherId == null || teacherId == undefined || teacherId <= 0 ){
			teacherId = 0;
		}
		var ajax = new XMLHttpRequest();
		var url = this.newContextPath+"teachers/get-loggedin-teacher/0"; //hostName+this.tanzeel.teacher.viewTeacherDetailScreen.toString().replace("{id}",""+teacherId);
		const token = this.getValidJwtToken();

		ajax.open("get" , url , false);
		if( token ){
			ajax.setRequestHeader('Authorization', `Bearer ${token}`);
		}

		if( this.getCachedObject("getLoggedInTeacher") != null) {
			//console.info(" Gender List is cached list ");
			return this.getCachedObject("getLoggedInTeacher")
		}
		
		try {
			ajax.send();
			if( ajax.status == 401 || ajax.status == 403 ){
				this.handleAuthenticationFailure();
				return null;
			}
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getLoggedInTeacher" , obj);
			console.info(" ==> getLoggedInTeacher ");
			 return obj;
		} catch (e) {
			console.info( e );
			return {};
		}
	}

	normalizeStudentVo(student:any):any {
		if( student == null || typeof student !== 'object' ){
			return student;
		}

		student = this.parseJsonBody(student);
		if( student == null || typeof student !== 'object' ){
			return student;
		}

		if( student.parentStudentId == null || student.parentStudentId === undefined ){
			student.parentStudentId = 0;
		}

		if( Array.isArray(student.dependents) ){
			student.dependents = student.dependents.map((dependent:any) => this.normalizeDependentVo(dependent));
		}

		return student;
	}

	normalizeDependentVo(dependent:any):any {
		if( dependent == null || typeof dependent !== 'object' ){
			return dependent;
		}

		if( dependent.studentRef != null ){
			this.normalizeStudentVo(dependent.studentRef);
		}

		return dependent;
	}

	isPrimaryStudent(student:any):boolean {
		if( student == null ){
			return false;
		}
		const parentId = student.parentStudentId;
		return parentId == null || parentId === undefined || Number(parentId) <= 0;
	}

	getLoggedInStudentAsync(studentId:number , owner:any , success:any , failure:any  ){
		if( studentId== undefined || studentId == null ){
			studentId = 0;
		}
		
		var url = this.newContextPath+"students/get-loggedin-student/"+studentId;
		url = url+"?randomdUINumber="+(Math.random()*100000);		
		this.makeGetHttpCall( url , owner , success , failure );

	}

	getLoggedInStudent(studentId?:number , logOut?:boolean ){
		if( studentId== undefined || studentId == null ){
			studentId = 0;
		}
		var ajax = new XMLHttpRequest();
		var url = this.newContextPath+"students/get-loggedin-student/"+studentId;
		url = url+"?randomdUINumber="+(Math.random()*100000);
		ajax.open("get" , url , false);
		const token = this.getValidJwtToken();
		if( token ){
			ajax.setRequestHeader('Authorization', `Bearer ${token}`);
		}
	    try {
            ajax.send();
            if (this.handleCardRecoveryResponse(ajax.status, ajax.responseText)) return null;
			if( (ajax.status == 401 || ajax.status == 403) && (logOut === true ==null || logOut === true )){
				this.handleAuthenticationFailure();
				return null;
			}
            var responseText = ajax.responseText;
            var obj = this.normalizeStudentVo(JSON.parse(responseText));
             return obj;
        } catch (e) {
			if( (ajax.status == 401 || ajax.status == 403) && (logOut === true ==null || logOut === true ))
				this.handleAuthenticationFailure();
			
            console.error( e );
            return null;
        }
	}

	searchCmsDrafts(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.system.searchCMSList.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}
	
	getNotificationTypeList( owner:any , success:any , failure:any ){
		var url = this.newContextPath+"common/notificationType/list";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getLoggedInStudentWithDependantInfo( owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/get-loggedin-studentwithdependentinfo" ;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getMessageTypeList( owner:any , success:any , failure:any ){
		var url = this.newContextPath+"common/messageseverity/list";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getUsersByRoleId( id:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"common/authuser/by/role/"+id;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getStudentsByTeacherId( id:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath +"students/byteacher/"+id+"/students";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	saveMessageNotifyRequest( value:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"common/save/notificationRequest";
        this.makePostHttpCall( url , value , owner , success , failure );
	}

	getUniqueStudentsListFromPayment(id: any, owner: any, success: any, failure: any) {
		var url = this.newContextPath+"students/search/studentfamily/list/"+id;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	searchStudentFamilyGrouping(searchPageCriteria: any, owner: any, success: any, failure: any) {
		try {
			var url = this.newContextPath + 'students/search/studentfamily';
			this.makePostHttpCall(url, searchPageCriteria, owner, success, failure);
		} catch (e) {
			failure.call(owner, { message: e });
			console.info(e);
		}
	}

	searchStudentDetailsReport(searchPageCriteria: any, owner: any, success: any, failure: any) {
		try {
			var url = this.tanzeel.student.searchStudentDetailsReport.toString();
			this.makePostHttpCall(url, searchPageCriteria, owner, success, failure);
		} catch (e) {
			failure.call(owner, { message: e });
			console.info(e);
		}
	}

	getBillingInfoForStudent(studentId:any,  owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/view/studentbillinginfo/"+studentId;//tanzeel.student.viewStudentBillingSummary.toString().replace( "#studentId" , studentId );
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getStudentCourseStatuses(studentId:any, owner:any, success:any, failure:any){
		var url = this.newContextPath+"students/student/course-statuses/"+studentId;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getStudentCourseStatusHistoryFilterOptions(owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/search/coursestatushistory/filteroptions";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	searchStudentCourseStatusHistory(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/search/coursestatushistory";
		this.makePostHttpCall( url , request , owner , success , failure );
	}

	getStudentCourseStatusHistoryForStudent(studentId:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/student/course-status-history/"+studentId;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getStudentCourseStatusHistoryRelatedFlowSessions(historyId:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/coursestatushistory/"+historyId+"/related-flow-sessions";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getCourseComponentsForCourse( courseId:any , addlOption:any , owner:any , success:any , failure:any ){
        var url = this.newContextPath+"course/getcoursecomponent/"+ courseId+"/true";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getTeacherCmsResources( teacherId:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"course/teacher/"+teacherId+"/cms/resources";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	searchStudentDonations( value:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/search/studentdonationlist";
        this.makePostHttpCall( url , value , owner , success , failure );
	}

	getClassCostTypeList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/classCostType/list" , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getClassCostTypeList") != null) {
				//console.info(" Gender List is cached list ");
				return this.getCachedObject("getClassCostTypeList")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getClassCostTypeList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	getServiceExprLevelList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/serviceExprLevel/list" , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getServiceExprLevelList") != null) {
				//console.info(" Gender List is cached list ");
				return this.getCachedObject("getServiceExprLevelList")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getServiceExprLevelList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	getPositiveFactorList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/positiveFactor/list" , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getPositiveFactorList") != null) {
				//console.info(" Gender List is cached list ");
				return this.getCachedObject("getPositiveFactorList")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getPositiveFactorList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	getCancelFactorList(){
		var ajax = new XMLHttpRequest();
        ajax.open("get" , this.newContextPath+"common/cancelFactor/list" , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getCancelFactorList") != null) {
				//console.info(" Gender List is cached list ");
				return this.getCachedObject("getCancelFactorList")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getCancelFactorList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }
	}

	saveStudentExitSurvey( survey:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/cancellation/save/survey";
        this.makePostHttpCall( url , survey , owner , success , failure);
	}

	getStudentDonationSummary(studentId:any , owner:any , success:any , failure:any ){
        var url = this.newContextPath+"students/view/studentdonationsummary/"+studentId ;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	deleteStopRecurringStudentDonation( studentDonation:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/update/stoprecurringdonations/"+studentDonation.student.id ;
        this.makePostHttpCall( url , studentDonation ,owner , success , failure);
	}

	getBillingHistoryForStudent(studentId:any , pageNumber:any , pageLength:any , order:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/search/studentpaymentlist/"+studentId+"/"+pageNumber+"/"+pageLength+"/"+order;
        this.makeGetHttpCall( url , owner , success , failure );
	}

	getStudentFinancialHistoryFilterOptions(owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/search/studentfinancialhistory/filteroptions";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getStudentFinancialHistoryFamily(parentStudentId:any , pageNumber:any , pageSize:any , pageOrder:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/search/studentfinancialhistory/"+parentStudentId+"/"+pageNumber+"/"+pageSize;
		if( pageOrder != null && pageOrder != undefined && pageOrder != '' ){
			url = url + "/" + pageOrder;
		}
		this.makeGetHttpCall( url , owner , success , failure );
	}

	searchStudentFinancialHistory(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/search/studentfinancialhistory";
		this.makePostHttpCall( url , request , owner , success , failure );
	}

	getStudentFinancialHistoryCharts(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/reports/studentfinancialhistory/charts";
		this.makePostHttpCall( url , request , owner , success , failure );
	}

	getStudentFlowSessionFilterOptions(owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/flow-session/filter-options";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	searchStudentFlowSession(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/search/flowsession";
		this.makePostHttpCall( url , request , owner , success , failure );
	}

	getStudentFlowSessionMetrics(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/reports/flowsession/metrics";
		this.makePostHttpCall( url , request , owner , success , failure );
	}

	getTrialConversionMetrics(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/reports/trial-conversion/metrics";
		this.makePostHttpCall( url , request , owner , success , failure );
	}

	searchTrialConversionCohort(request:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/search/trial-conversion/cohort";
		this.makePostHttpCall( url , request , owner , success , failure );
	}

	getTrialConversionStudentDetail(studentId:any , month:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/reports/trial-conversion/student/"+studentId+"/"+encodeURIComponent(month);
		this.makeGetHttpCall( url , owner , success , failure );
	}

	searchStudentWeeklySchedule(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.student.searchStudentTimeSlots.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchMeetingForAttendance(sc:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"course/meeting/searchmeetinglistscreen";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchStudentDashboardData( data:any , owner:any , success:any , failure:any ){
		var url:any = null;//this.newContextPath+"students/search/studentdashboard/"+moreItems;
		if( data["studentId"] != null )
			url = this.newContextPath+"students/search/studentdashboard/"+data["moreItems"]+"/"+data["studentId"];
		else 
			url = this.newContextPath+"students/search/studentdashboard/"+data;
		this.makePostHttpCall( url , {} , owner , success , failure);
	}
	
	searchStudentDashboardDataWithDependentInfo( moreItems:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/search/studentdashboard2/"+moreItems;
		this.makePostHttpCall( url , {} , owner , success , failure);
	}

	searchMeetingForRecordingList(sc:any , owner:any , success:any , failure:any){
        var url = this.contextPath+"/controller/course/search/meetingListsForRecordings";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchStudentConsentList(sc:any , owner:any , success:any , failure:any){
        var url = this.contextPath+"/controller/student/search/studentconsentsummary";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchTeacherWeeklySchedule(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.teacher.searchTeacherTimeSlots.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}
	
	searchSystemAuditsSchedule(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.system.searchSystemAuditScreen.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	// @TODO Fairoz
	SearchStudentScholarshipList( request:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/search/studentscholarshipapplist";
        this.makePostHttpCall( url , request  , owner , success , failure );
	}

	searchDonationDrivelList(sc:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"system/donationdrive/list";
        this.makePostHttpCall( url, sc , owner , success , failure );
	}

	getSuitableDonationDrive(owner:any , success:any , failure:any){
        var url = this.newContextPath+"system/donationdrive/suitable";
        this.makeGetHttpCall( url ,  owner , success , failure );
	}

	getStudentBillingPDFReport(id:any , owner:any , success:any , failure:any ){
        //var url = this.tanzeel.student.viewStudentMonthlyBillingStatement.toString().replace("#paymentId", id );
		//this.makeGetHttpCall( url , owner , success , failure , null , "text");
		throw new Error(" Not Implemented ");
	}

	searchStudentRecordsLog(sc:any , owner:any , success:any , failure:any , downloadFile?:any){
        var url = this.newContextPath+"students/search/cancellation/survey";
		if( downloadFile == undefined )
        	this.makePostHttpCall( url , sc , owner , success , failure );
		else
			this.makePostHttpCall( url , sc , owner , success , failure , null , "text/text" ); 
	}
	
	intiateOTPToVerifyMobile( contact:any , owner:any , success:any , failure:any ){
        var url = this.newContextPath+"system/verifycontact/sendotp/contact";
		this.makePostHttpCall( url , contact , owner , success , failure ); 
	}
	
	validateOTPForNumber( contact:any , otp:string , owner:any , success:any , failure:any ){
        var url = this.newContextPath+"common/auth/verifyOtp/"+otp;

		this.makePostHttpCall( url , contact , owner , success , failure ); 
	}

	intiateOTPToVerifyMobileForSupport( contact:any , owner:any , success:any , failure:any ){
        var url = this.newContextPath+"system/supportticket/sendotp/verifyNumber";
		this.makePostHttpCall( url , contact , owner , success , failure ); 
	}
	
	validateOTPForNumberForSupport( contact:any , otp:string , owner:any , success:any , failure:any ){
        var url = this.newContextPath+"system/supportticket/verifyotp/"+otp;

		this.makePostHttpCall( url , contact , owner , success , failure ); 
	}

	searchTrialStudentSurveyRecordsLog(sc:any , owner:any , success:any , failure:any , download?:any){
        var url = this.newContextPath+"students/search/trial/survey";
		if( download == undefined || download == null )
        	this.makePostHttpCall( url , sc , owner , success , failure );
		else 
			this.makePostHttpCall( url , sc , owner , success , failure , null , "text/text");
	}

	searchStudentSwitchTeacherRecordsLog(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.student.searchStudentSwitchTeacherRecords.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchStudentTransferToTeacherRecordsLog(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.student.searchStudentTransferRecord.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}
	
	deleteStudentSwitchTeacherRecordsLog( value:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.serviceUrls.student.deleteStudentTeacherPref.toString();
        this.makePostHttpCall( url , value , owner , success , failure );
	}

	// @TODO Fairoz
	deleteScholarShipApplication(value:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.student.deleteScholarshipApplView.toString();
        this.makePostHttpCall( url , value , owner , success , failure );
	}

	// @TODO Fairoz
	saveScholarshipApplication(val:any, owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/student/saveScholarshipApplView";
		this.makePostHttpCall( url , val , owner , success , failure);
	}

	saveUpdateDonationDrive(val:any, owner:any , success:any , failure:any ){
		var url = this.tanzeel.donor.saveDonationDriveView.toString();
		this.makePostHttpCall( url , val , owner , success , failure);
	}

	uploadDonationDriveImageFile(val:any, owner:any , success:any , failure:any ){
		let headers = new Headers();
		var url = this.tanzeel.serviceUrls.donor.uploadDonationDriveImageFile.toString();
		this.makePostHttpCall( url , val , owner , success , failure , headers);
	}

	uploadConsentScreenShot( value: any ,owner:any , success:any , failure:any ){
		let headers = new Headers();
        let formData: FormData = new FormData();

        //for( var ctr = 0; ctr < value.file.length; ctr++){
			formData.append("file", value.file , "test");
			
			formData.append("studentId", value.studentId );
        //}
       /*var formData = {
		   file :value.file,
		   studentId : value.studentId 
	   };*/
		var url = this.contextPath+"controller/student/studentconsent/digitalscreenshot/uploadPicture";
		this.makePostHttpCall( url , formData , owner , success , failure , headers);
	}

	saveConsentApproved( studentConsent:any , owner:any , success:any , failure:any , parentalPassword:string ){
		let headers = new Headers();

		var url = this.contextPath+"controller/student/studentconsent/savestudentconsent/0000";
		if( parentalPassword != null )
			url = this.contextPath+"controller/student/studentconsent/savestudentconsent/" + md5(parentalPassword);
		this.makePostHttpCall( url , studentConsent , owner , success , failure , headers);
	}

	saveConsentApprovedAll( studentConsent:any , owner:any , success:any , failure:any , parentalPassword:string ){
		let headers = new Headers();

		var url = this.contextPath+"controller/student/studentconsent/savestudentconsentall/0000";
		if( parentalPassword != null )
			url = this.contextPath+"controller/student/studentconsent/savestudentconsentall/" + md5(parentalPassword);
		this.makePostHttpCall( url , studentConsent , owner , success , failure , headers);
	}

	getAvailableTeacherForStudent(studentId:number , owner:any , success:any , failure:any ){
        var url = this.newContextPath+"students/search/teacheravailablelist/"+studentId;
        this.makeGetHttpCall( url , owner , success , failure);
	}
	
	getAvailableTeacherForStudentTransfer(studentId:number , owner:any , success:any , failure:any ){
        var url = this.contextPath+"/controller/student/search/getStudentTransferTeachers/"+studentId;
        this.makeGetHttpCall( url , owner , success , failure);
    }

	studentHasDonationHistory( owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/studentdonations/getstudenthasdonationhistory";
        this.makeGetHttpCall( url , owner , success , failure);
	}

	getStudentsDonationDrives( id:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/studentdonations/getstudentdonationdrives";
        this.makeGetHttpCall( url , owner , success , failure);
	}

	viewStudentDonationScreen(studentId:any,  owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/view/studentdonationscreen/"+studentId;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	saveStudentDonationScreen(val:any, owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/save/studentdonationscreen";
		this.makePostHttpCall( url , val , owner , success , failure);
	}

	searchDonationDrivelListForSummary(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.donor.searchDonationDriveList.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchDonationDriveStudentList(sc:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/search/donationdrivestudentlist";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	downloadCSVReportDonationDrive( id:any,owner:any , success:any , failure:any ){
		var url = this.tanzeel.student.viewStudentDonationCSV.toString().replace("#donationDriveId" , id);
		this.makeGetHttpCall( url , owner , success , failure);
	}

	searchStudentRefundFilter(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.student.searchStudentRefundList.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchDonationPoolFilter(sc:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.donor.searchDonationPoolList.toString();
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	saveStudentRefund(val:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.student.saveStudentRefundView.toString();
        this.makePostHttpCall( url , val , owner , success , failure );
	}

	saveStudentCredit(val:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.serviceUrls.student.saveStudentCredit.toString();
        this.makePostHttpCall( url , val , owner , success , failure );
	}

	convertTimeUsingTimeZone( fromTimezone:any , toTimezone:any  ,owner:any , success:any , failure:any ){
		var url = this.tanzeel.common.convertTime.toString().replace("#sourceTZ",fromTimezone.replace(new RegExp('/', 'g') , '^^^') ).replace("#targetTZ" , toTimezone.replace(new RegExp('/', 'g') , '^^^') );
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getDonationSummaryForPoolType(poolType:string , owner:any , success:any , failure:any ){
		var url = this.contextPath+"/controller/donor/view/donationpoolsummary/"+poolType
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getOnGoingMeetingList(owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/search/getongoingmeetingsforstudent/0";
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getOnGoingMeetingListUsingStudent( studentRef:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/search/getongoingmeetingsforstudent/"+studentRef.id;
		this.makeGetHttpCall( url , owner , (data:any)=>{
			if( owner != null && success!= null ){
				success.call( owner , studentRef , data );
			}
		}, (error:any)=>{
			if( owner != null && failure!= null )
				failure.call( owner , studentRef , error );
		});
	}
	
	completePaymentReviewed( data:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/enrollment/reviewcomplete";
		this.makePostHttpCall( url , data , owner , success , failure);
	}

	getMeetingLinkUsingMeetingId(meetingId:string , owner:any , success:any , failure:any , classRoomType:string , studentId?:any ){
		var url = this.contextPath+"/controller/course/meeting/getMeetingLinkForMeetingId/"+meetingId+"/"+classRoomType;
		if( studentId != null && studentId > 0 )
			url = this.contextPath+"/controller/course/meeting/getMeetingLinkForMeetingId/"+meetingId+"/"+classRoomType+"/"+studentId;

		this.makeGetHttpCall( url , owner , success , failure);
	}

	saveStudentTeacherLastSeenForMeetingId(meetingId:string , owner:any , success:any , failure:any , classRoomType:string , studentId?:any){
		var url = this.tanzeel.course.updateMeetingStatus.toString().replace("#authUserId" , "0").replace("#meetingId" , meetingId);
		if( studentId != null )
			url+= "/"+studentId;

		url+= "/"+classRoomType;

		this.makeGetHttpCall( url , owner , success , failure);
	}

	saveToArtificialPool(val:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.serviceUrls.donor.saveDonationPool.toString();
        this.makePostHttpCall( url , val , owner , success , failure );
	}

	getSetupPaymentSecret(){
		var ajax = new XMLHttpRequest();
        ajax.open("post" , this.newContextPath+"students/studentcard/createsetupintent" , false);
		const token = this.getValidJwtToken();
		if( token ){
			ajax.setRequestHeader('Authorization', `Bearer ${token}`);
		}    
        try {
            ajax.send("{}");
			var responseText = ajax.responseText;
			if( ajax.status == 200 ){
            	var obj = JSON.parse(responseText);
             	return obj;
			}else {
				return "Invalid key ";
			}

        } catch (e) {
            console.info( e );
            return "Invalid key ";
        }		
	}

	searchEmailTemplates(sc:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"system/search/emailtemplatesscreen";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	skipEmailsFlagSwitch(flag:any , owner:any , success:any , failure:any){
        var url = this.contextPath+"controller/system/emails/skipemailflag/"+flag;
        this.makePostHttpCall( url , {} , owner , success , failure );
	}

	saveEmailTemplate(sc:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"system/save/emailtemplate";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	senEmailTemplateToStudent(sc:any , owner:any , success:any , failure:any){
        var url = this.contextPath+"controller/system/send/sendEmailToStudent";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	getServerSystemDateTime(owner:any , success:any , failure:any ){
		var url = this.newContextPath+"system/get/systemdefault/settings";
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getSystemDefaultSettingsMock(owner:any , success:any , failure:any){
		setTimeout(()=>{
			try {
				var settings = this.getStoredMockSystemDefaultSettings();
				if( success ){
					success.call(owner, this.createMockHttpResponse(settings));
				}
			} catch (error) {
				if( failure ){
					failure.call(owner, this.createMockHttpResponse(error, 500));
				}
			}
		}, 250);
	}

	getAllTeacherList(owner:any , success:any , failure:any ){
		var url = this.newContextPath+"teachers/teacher/list";
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getAllTeacherListWithUtilRate(owner:any , success:any , failure:any ){
		var url = this.contextPath+"rest/teacher/teacher/list/calcratings"
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getTeacherUtilizationSummary(owner:any , success:any , failure:any ){
		var url = this.newContextPath+"teachers/search/teacher-utilization-summary";
		this.makeGetHttpCall( url , owner , success , failure);
	}
	


	setServerSystemDateTime(localDateTime:any , owner:any , success:any , failure:any , password:string){
        var url = this.tanzeel.system.setSystemDateTime.toString().replace("#adminPassword" , password);
        this.makePostHttpCall( url , localDateTime , owner , success , failure );
	}

	updateSystemDefaultSettings(settings:any, adminPassword:string , owner:any , success:any , failure:any){
		var url = this.newContextPath+"system/save/systemdefault/settings/"+adminPassword;
        this.makePostHttpCall( url , settings , owner , success , failure );
	}


	executeTanzeelMonthlyScheduler(owner:any , success:any , failure:any , password:string , studentIds:string){
		var url = this.newContextPath+"students/student/processmonthlypayments/{password}/{studentIds}".replace("{password}", password).replace("{studentIds}", studentIds);
		this.makePostHttpCall( url , {}, owner , success , failure);
	}

	executeZeroBillingScheduler(owner:any , success:any , failure:any , password:string , studentIds:string){
		var url = this.newContextPath+"system/processzeromonthlypayments/{password}/{studentIds}".replace("{password}", password).replace("{studentIds}", studentIds);
		this.makePostHttpCall( url , {}, owner , success , failure);
	}

	executeTanzeelObserveDelayedPayments(owner:any , success:any , failure:any , password:string){
		var url = this.tanzeel.system.processDelayedPayments.toString().replace("#adminPassword" , password);
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getSystemTestCasesList(owner:any , success:any , failure:any){
		var url = this.contextPath+"controller/system/systemtestcase/list";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getSystemExecuteTestCase(actionName:string , testName:string , password:string , owner:any , success:any , failure:any){
		var url = this.contextPath+"controller/system//update/systemtestcase/"+testName+"/"+actionName+"/"+password;
		this.makePostHttpCall( url , "" , owner , success , failure);
	}

	getStudentRescheduleHome(studentId:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/student/booked/appointments/"+studentId+"/1"; // 1 is courseid
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getEmailTemplatingFieldList( owner:any , success:any , failure:any ){
		var url = this.contextPath+"controller/system/emailtemplating/fieldsList";
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getEmailTemplateHtmlFile( url:string , owner:any , success:any , failure:any ){
		let headers = new HttpHeaders().set("content-type", "text/plain");
		this.makeGetHttpCall( url , owner , success , failure , headers , "text");
	}

	deleteCourseById( course:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.course.deleteCourseScreen.toString();
        this.makePostHttpCall( url , course , owner , success , failure );
	}

	searchTeachers( teacherData: any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"teachers/search/teacherlistscreen";
		this.makePostHttpCall( url , teacherData , owner , success , failure);
	}
	
	generateMeetingids( val:string , password:string , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"/course/meeting/generatelinks/tillnextmonth/"+ val +"/"+ password;
		this.makePostHttpCall( url, {} , owner , success , failure);
	}

	generateMeetingidsStaffUser( val:string , owner:any , success:any , failure:any ){
		var url = this.contextPath+"controller/course/generatemeetingidsForStaff/"+ val ;
		this.makeGetHttpCall( url , owner , success , failure , null , "text");
	}

	synchronizeEdxCourses(  password:string , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"notes/books/list/"+password;
		this.makePostHttpCall( url, {} , owner , success , failure , this.getTrialCsrfHeader());
	}

	generateMeetingStudentTeacher( teacherId:any , studentId:any , owner:any , success:any , failure:any ){
		var url = this.contextPath.toString()+"/controller/course/generatemeetinglinkForStudentTeacher/"+teacherId+"/"+studentId;//this.tanzeel.student.getStudentListByTeacher.toString().replace("#teacherId" , id);
		this.makeGetHttpCall( url , owner , success , failure , null , "text" );
	}

	iOS_version() { 
		if(navigator.userAgent.match(/ipad|iphone|ipod/i)){ //if the current device is an iDevice
		var ios_info ={};
		ios_info['User_Agent']=navigator.userAgent;
		ios_info['As_Reported']=(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0];
		ios_info['Major_Release']=(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].split('_')[0];
		ios_info['Full_Release']=(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].replace(/_/g,".");
		ios_info['Major_Release_Numeric']=+(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].split('_')[0].replace("OS ","");
		ios_info['Full_Release_Numeric']=+(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].replace("_",".").replace("_","").replace("OS ","");   //converts versions like 4.3.3 to numeric value 4.33 for ease of numeric comparisons
		return(ios_info);
		}
		return null;
	}

	sendLogToServer( str:string ){
		var url = this.contextPath.toString()+"/controller/system/logs/storetologfile";
		this.makePostHttpCall( url , str , null , null , null);		
	}

	saveStudentDashboardProfile(obj:any, owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/student/update/"+obj.id+"/profile"
		this.makePostHttpCall( url , obj , owner , success , failure); 
	}

	invokeStudentFailedPayment(studentId:any , owner:any , success:any , failure:any , timezoneCode?:string ){
		
		var url = this.newContextPath+"system/exec/invokefailedpayment/outstanding/student/"+studentId;
		this.makePostHttpCall( url , {}, owner , success , failure );
	}

	getTeacherMeetingsPastTenDays( teacherId:any, studentId:any , rangeId:any  , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"notes/teachermeetings/fornotes/daterange/"+teacherId+"/"+studentId+"/"+rangeId;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	searchClassNotes(sc:any , owner:any , success:any , failure:any){
        var url = this.contextPath+"/controller/openedx/search/classnotes";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchClassNotesMeetingForAttendance(sc:any , owner:any , success:any , failure:any){
        var url = this.contextPath+"/controller/openedx/search/classnotesmeetings";
        this.makePostHttpCall( url , sc , owner , success , failure );
	}

	getTeachersAvailableMultiScheduleForStudent(studentId:any , owner:any , success:any , failure:any , timezoneCode?:string ){
		
		var str = this.tanzeel.serviceUrls.student.getAvailableTimeSlots.toString().replace("#studentId", studentId);
		if( timezoneCode == undefined || timezoneCode == null || timezoneCode == ''){
			str = str.replace('#slotsType','multiple').replace('#tzaCode','000');
		}
		else {
			str = str.replace('#slotsType','multiple').replace('#tzaCode',timezoneCode);
		}
		this.makeGetHttpCall( str , owner , success , failure );
	}

	getTeachersAvailableMultiScheduleForStudentReschedule(studentId:any , dur:any , owner:any , success:any , failure:any , timezoneCode?:string ){
		
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
        let options = { headers: headers };
		
		var url = this.newContextPath+"students/student/availableSlots/reschedule/"+studentId;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getTeachersAvailableMultiScheduleForTrialStudentReschedule(studentId:any , owner:any , success:any , failure:any , timezoneCode?:string ){
		var url = this.newContextPath+"students/student/availableSlots/reschedule/"+studentId;
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getCurrentClasses(owner:any , success:any , failure:any ){
        let url = this.newContextPath+"teachers/teacher/classes/currentclasses/all";
        this.makePostHttpCall( url , {} , owner , success , failure);
    }

	sendStudentRescheduleSlotsForReview(studentid:any , data:any, owner:any , success:any , failure:any ){
        var url = this.newContextPath+"students/student/reschedule/slotsreview/"+studentid;
		this.makePostHttpCall( url , data , owner , success , failure);
	}

	saveStudentMultipleSchedule(url:string , data:any, owner:any , success:any , failure:any ){
		url = this.newContextPath + url;
		this.makePostHttpCall( url , data , owner , success , failure);
	}

	sendStudentRescheduleSlotsForReviewTrial(data:any, owner:any , success:any , failure:any ){

        var url = this.tanzeel.trialContextPath+"controller/student/save/studentreschedule";
		this.makePostHttpCall( url , data , owner , success , failure, this.getTrialCsrfHeader() );
	}

	sendStudentSlotsForConfirmPaymentsTrial(data:any, owner:any , success:any , failure:any ){		 
		var url = this.tanzeel.trialContextPath+"controller/student/save/studentconfirmpayment";
		this.makePostHttpCall( url , data , owner , success , failure , this.getTrialCsrfHeader() );
	}

	sendStudentSlotsForConfirmPayments(studentid:any , data:any, owner:any , success:any , failure:any ){	 
		var url = this.newContextPath+"students/student/reschedule/completereview/"+studentid;
		this.makePostHttpCall( url , data , owner , success , failure);
	}

	sendStudentConvertDurationSlotsForReview(studentid:any , data:any, owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/student/reschedule/convertduration/review/"+studentid;
		this.makePostHttpCall( url , data , owner , success , failure);
	}

	sendStudentConvertDurationForConfirm(studentid:any , data:any, owner:any , success:any , failure:any ){
		var url = this.newContextPath+"students/student/reschedule/convertduration/complete/"+studentid;
		this.makePostHttpCall( url , data , owner , success , failure);
	}

	getTeacherDashboardScheduleWeekly( teacherId:any , type:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"teachers/teacher/dashschedule/"+teacherId+"/"+type;
		this.makePostHttpCall( url , {} , owner , success , failure);
	}

	updateRatePerClass( data:any, owner:any , success:any , failure:any ){
		var url = this.contextPath+"controller/system/update/raretperclass/"+data;
		this.makePostHttpCall( url , data , owner , success , failure , null  , "text");
	}

	pingServerHeartBeat( owner:any , success?:any , failure?:any ){

		fetch('assets/images/pingServer.json?randomdUINumber='+(Math.random()*100000), { method : 'POST'}).then(( value)=>{
			if( success && owner )
				setTimeout( ()=>{ success.call( success.call( owner )) } , 2000 );
		} ,(reason)=>{
			if( failure && owner )
				setTimeout( ()=>{ failure.call( owner) } , 2000 );
		})
	}

	isEditAllowed(){
		if( this.tanzeel != null && this.tanzeel.secureUser != null && this.tanzeel.secureUser.allowEdit==false){
			return false;
		}
		return true;
	}

	convertToDate( singleDate: TanzeelDateInput | IMySingleDateModel ){
		return TanzeelDateUtil.toDate( singleDate );
	}

	convertToMoment( singleDate: TanzeelDateInput | IMySingleDateModel ){
		return TanzeelDateUtil.toMoment( singleDate );
	}

	isDateBeyondSixDays( momentRef:any ):boolean{
		if( momentRef == null ){
			return false;
		}

		var referenceMoment = moment( momentRef );
		if( referenceMoment.isValid() == false ){
			return false;
		}

		var maxAllowedDate = moment().add(6, 'days');
		return referenceMoment.isAfter( maxAllowedDate , 'day' );
	}

	convertToFormattedYYYYMMDD( singleDate: TanzeelDateInput | IMySingleDateModel ):string{

		return TanzeelDateUtil.formatApi( singleDate );

	}

	convertToIDateObject( momdate:any ){ // should be a moment object
		return TanzeelDateUtil.toLegacyDateParts( momdate );
	}

	convertFromDateToIDateObject( mdate:Date ){
		return TanzeelDateUtil.toLegacyDateParts( mdate );
	}

	isNonProduction():boolean {
		if( location.hostname.indexOf("lz.tanzeel.org")!=-1 ){
			return false;
		}
		return true;
	}

	autoLoginChatServer( username:string , owner:any, success:any, failed:any){
		
		var body = username;
		this.makePostHttpCall( "/tanzeelchat/security/custom/login?username="+this.tanzeel.secureUser.username  , body , this , (data:any)=>{
				//console.info( "makePostHttpCall-autoLoginTrialAccount : success ");
			this.initIMS();
			if( owner != null && success!= null )
				success.call( owner );
		}, (error:any)=>{
			console.info( "makePostHttpCall-autoLoginTrialAccount : failed!! ");
			if( owner != null && failed!= null )
				failed.call( owner );
		} );
	}

	_messageRecievedObserver:any = null;
	_messageRecievedObservable:any = new Observable( (observer:any) => { this._messageRecievedObserver = observer; });
	stompClient:any = null;

	socketDisconnectObserver:any = null; 
	socketDisconnectObservable = new Observable( (observer:any) => { this.socketDisconnectObserver = observer; });	

	initIMS(){
		if( this.isNonProduction() == false ){
			//return;
		}


		var socket = new SockJS( '/tanzeelchat/tanzeel/portfolio'  );
		
		this.socketDisconnectObservable.subscribe(  val=> {});
		this._messageRecievedObservable.subscribe(  val=> {});

		console.clear();
		this.stompClient = Stomp.over(socket);
		var _thisRef = this;
		//XSRF-TOKEN
		//X-XSRF-TOKEN
		var headers = {};


		this.stompClient.connect( headers,  (frame:any) =>{
		this.stompClient.subscribe('/user/exchange/amq.direct/test/hello', (message)=> {
				try {
					var msgObject = JSON.parse( message.body );

					if( msgObject.messageType == "handshakeInitiate"){

						this.userHandShakeResponse( msgObject.fromUser );
					}
					if( this._messageRecievedObserver!= null && this._messageRecievedObserver.next ){

						this._messageRecievedObserver.next( msgObject );
					}
					else {
						console.info( " this._messageRecievedObserver.next : is null strange" )
					}

					if( msgObject.messageType == 'message' ){
						//console.info( " message recieved : "+ msg );

						if( this.messageList == null )
							this.messageList = {};
						
						this.addMessageToList( msgObject.fromUser , msgObject );
					}
					//console.info( " message recieved : "+ msg );
				} catch (error) {
					console.error( error );					
				}
			});
		}, (message:any)=>{
			console.info(" got disconnected inform the host to reconnect IA ");
			if( this.socketDisconnectObserver && this.socketDisconnectObserver.next ){
				this.socketDisconnectObserver.next("hello");
			}
		});
    }

	disconnectStompWS(){
		try {
			this.stompClient.disconnect( ()=>{ console.info("Disconnected "); } , {});
		} catch (error) {}
	}

	messageList:any = {};
    sendTextMessage( user:string , msg:string , channelId:any , username:any  ){
		var url = "/app/test/hello."+user;
        if( this.stompClient ){
			this.sendGenericMessage( msg , user , "message" , url , channelId, username );
        }        
	}

	addMessageToList( user:any , msg:any  ){
		if( this.messageList[ user ] == undefined || this.messageList[ user ] == null ){
			this.messageList[ user ] = [];
		}
		this.messageList[ user ].push(msg);
	}

	sendGenericMessage( message:any , user:string , messageType:string , url:string  , channelId?:any , username?:any){
		var msg = { "message" : message  , "fromUser" : this.tanzeel.secureUser.username , "toUser" : user , "messageType" : messageType , "time": moment().format()};
		if( username != null && username != undefined )
			msg["fromUserName"] = username;
		if( channelId != null && channelId > 0 ){
			msg["channel"] = { id: channelId };
		}
		if( this.stompClient ){
			var id = this.stompClient.send( url , {} , JSON.stringify( msg ) );
			//console.info( " id : "+ id );

			if( msg.messageType == 'message' ){
				if( this.messageList == null )
					this.messageList = {};
				if( this.messageList[ msg.toUser ] == undefined || this.messageList[ msg.toUser ] == null ){
					this.messageList[ msg.toUser ] = [];
				}
				this.addMessageToList( msg.toUser , msg );
			}
        }        
	}

	userHandShakeInitiate( user:string ){
		try {
			var url = "/app/test/hello."+user;
			if( this.stompClient ){
				this.sendGenericMessage( "handshake" , user , "handshakeInitiate" , url );
			}
		} catch (error) {
			
		}
	}

	userHandShakeResponse( user:string ){
		var url = "/app/test/hello."+user;
		if( this.stompClient ){
			this.sendGenericMessage( "handshake" , user , "handshakeResponse" , url );
		}
	}

	sendBrowserLogInfo(prefixMessage:string){
		try {
			var objappVersion = navigator.appVersion; 
			var objAgent = navigator.userAgent;
			var objbrowserName = navigator.appName; 
			var objfullVersion = ''+parseFloat(navigator.appVersion);
			var objBrMajorVersion = parseInt(navigator.appVersion,10);
			var objOffsetName,objOffsetVersion,ix; 
			// In Chrome 
			if ((objOffsetVersion=objAgent.indexOf("Chrome"))!=-1) { objbrowserName = "Chrome"; objfullVersion = objAgent.substring(objOffsetVersion+7); } 
			// In Microsoft internet explorer 
			else if ((objOffsetVersion=objAgent.indexOf("MSIE"))!=-1) { objbrowserName = "Microsoft Internet Explorer"; objfullVersion = objAgent.substring(objOffsetVersion+5); } 
			// In Firefox 
			else if ((objOffsetVersion=objAgent.indexOf("Firefox"))!=-1) { objbrowserName = "Firefox"; } 
			// In Safari 
			else if ((objOffsetVersion=objAgent.indexOf("Safari"))!=-1) { objbrowserName = "Safari"; objfullVersion = objAgent.substring(objOffsetVersion+7); 
			if ((objOffsetVersion=objAgent.indexOf("Version"))!=-1) objfullVersion = objAgent.substring(objOffsetVersion+8); } 
			// For other browser "name/version" is at the end of userAgent 
			else if ( (objOffsetName=objAgent.lastIndexOf(' ')+1) < (objOffsetVersion=objAgent.lastIndexOf('/')) ) { objbrowserName = objAgent.substring(objOffsetName,objOffsetVersion); objfullVersion = objAgent.substring(objOffsetVersion+1); 
			if (objbrowserName.toLowerCase()==objbrowserName.toUpperCase()) { objbrowserName = navigator.appName; } } 
			// trimming the fullVersion string at semicolon/space if present 
			if ((ix=objfullVersion.indexOf(";"))!=-1) objfullVersion=objfullVersion.substring(0,ix); 
			if ((ix=objfullVersion.indexOf(" "))!=-1) objfullVersion=objfullVersion.substring(0,ix); objBrMajorVersion = parseInt(''+objfullVersion,10); 
			if (isNaN(objBrMajorVersion)) { objfullVersion = ''+parseFloat(navigator.appVersion); objBrMajorVersion = parseInt(navigator.appVersion,10); }

			var str = 'Browser name = '+objbrowserName+'\n\t' +'Full version = '+objfullVersion+'\n\t' +'Major version = '+objBrMajorVersion+'\n\t' +'navigator.appName = '+navigator.appName+'\n\t' +'navigator.userAgent = '+navigator.userAgent+'\n';
			this.sendLogToServer( prefixMessage+"\n\t"+str );

		} catch (error) {}
	}

	gaInit(){
		try {
			var gaobject =  { 'send_to': this.tanzeel.GATrackingID };
			if( this.tanzeel.secureUser != null && this.tanzeel.secureUser.role != null && this.tanzeel.secureUser.role.toLowerCase() == 'student'){
				if( this.tanzeel.secureUser["studentId"] != null )
					gaobject['user_id'] =  this.tanzeel.secureUser["studentId"];
			}
			gtag('set', gaobject);
				
		} catch ( err ) {
			console.error ( err );
		}
	}
	ga_registerEvent(){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				gtag('event', 'self_register_event' , {'send_to': this.tanzeel.GATrackingID});
				this.initiateCheckoutGA();
			//}				
		} catch ( err ) {
			console.error ( err );
		}

	}

	studentSusbcribeGAEvent( paid:boolean ){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				if( paid == false ){
					gtag('event', 'student_subscribe_trial' , {'send_to': this.tanzeel.GATrackingID});
					this.startTrialGA();
				}else {
					gtag('event', 'student_subscribe_paid_posttrial' , {'send_to': this.tanzeel.GATrackingID});
					this.startSubscriptionGA( 0 );
				}
			//}			
		} catch ( err ) {
			console.error ( err );
		}

	}

	addPaymentInfoGA(){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				fbq('track', 'AddPaymentInfo')
			//}			
		} catch ( err ) {
			console.error ( err );
		}

	}

	addToCartGA(trialClass:boolean){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				if( trialClass == true)
					fbq('trackCustom', 'TrialClassAdded');
				else 
					fbq('trackCustom', 'ClassAdded');
			//}			
		} catch ( err ) {
			console.error ( err );
		}

	}

	donateSelectedGA(){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				fbq('trackCustom', 'DonationSelected');
			//}
				
		} catch ( err ) {
			console.error ( err );
		}
	}
	
	donateGA(){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				fbq('track', 'Donate');
			//}
				
		} catch ( err ) {
			console.error ( err );
		}
	}

	initiateCheckoutGA(){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				fbq('trackCustom', 'AccountCreated');
			//}			
		} catch ( err ) {
			console.error ( err );
		}

	}

	initiateCheckoutDependentGA(){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				fbq('trackCustom', 'DependentAccountCreated');
			//}			
		} catch ( err ) {
			console.error ( err );
		}

	}

	startSubscriptionGA(amount:any){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				fbq('trackCustom', 'PaidEnrolmentCompleted', {value: (''+amount), currency: 'USD', predicted_ltv: '0.00'});
			//}			
		} catch ( err ) {
			console.error ( err );
		}

	}

	startTrialGA(){
		try {
			//if( this.isNonProduction()==false ){
				this.gaInit();
				fbq('trackCustom', 'TrialRegistrationCompleted', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'});
			//}			
		} catch ( err ) {
			console.error ( err );
		}

	}
	private _pageTitle:string = null;
	get pageTitle(){
		return this._pageTitle;
	}
	
	changeWindowTitle( titleSuffix:string ){
		//if( window && window.document && window.document.title )	
			this._pageTitle = "TANZEEL LEARNING ZONE ( "+titleSuffix+"1.0 )";	
	}

	sendPromotionEmails(val:any , owner:any , success:any , failure:any){
        var url = this.tanzeel.trialContextPath+"/controller/course/save/promotionnomination";
        this.makePostHttpCall( url , val , owner , success , failure  , this.getTrialCsrfHeader()  );
	}

	getTeachersAvailableScheduleForStudentWithTeacherId(studentId:any , duration:any , teacherId:any, paidenrollment:boolean ,  owner:any , success:any , failure:any ){
		
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
        let options = { headers: headers };
        var str = this.newContextPath+"students/student/availableSlots/#studentId/#teacherId/#durationMts/#paidenrollment";

		str = str.replace('#durationMts',duration );
		str = str.replace('#teacherId',teacherId );
		str = str.replace('#studentId',studentId );
		str = str.replace('#paidenrollment',""+paidenrollment );
		console.info( " str "+str);
		this.makeGetHttpCall( str , owner , success , failure );
	}

	saveMakeUpClassMeeting(val:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/view/makeupclass/createdelete?trial=false";
        this.makePostHttpCall( url , val , owner , success , failure );
	}

	saveTrialMakeUpClassMeeting(val:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"students/view/makeupclass/createdelete?trial=true";
        this.makePostHttpCall( url , val , owner , success , failure );
	}

	searchMakeUpClassForStudent(studentId:any , historical:any ,  owner:any , success:any , failure:any ){
		
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
        let options = { headers: headers };
        var str = this.newContextPath+"students/view/makeupclass/list/#studentId/#historical";

		str = str.replace('#studentId',studentId )
					.replace('#historical',historical );

		this.makeGetHttpCall( str , owner , success , failure );
	}

	getInitialSupportTicket( owner:any , success:any , failure:any ){
        var str = this.newContextPath+"system/supportticket/initialdetails";
		this.makeGetHttpCall( str , owner , success , failure );
	}

	saveSupportTicketRef(val:any , owner:any , success:any , failure:any){
        var url = this.newContextPath+"system/save/supportticket";
        this.makePostHttpCall( url , val , owner , success , failure );
	}

	private _previousUrl:any = null;

	get previousUrl(){
		return this._previousUrl ; 
	}

	set previousUrl( url:any ){
		this._previousUrl = url; 
	}

	getSupportTicketComments(stId:any ,  owner:any , success:any , failure:any ){
		var url = this.newContextPath+"system/supportticketcomment/list/"+stId;
		this.makeGetHttpCall( url , owner , success , failure );
	}

    getClassChangeLogOptions(owner:any, success:any, failure:any) {
        this.makeGetHttpCall(this.newContextPath + 'students/class-change-log/options', owner, success, failure);
    }

    searchClassChangeLog(request:any, owner:any, success:any, failure:any) {
        this.makePostHttpCall(this.newContextPath + 'students/class-change-log/search', request, owner, success, failure);
    }

    getClassChangeLog(id:string, owner:any, success:any, failure:any) {
        this.makeGetHttpCall(this.newContextPath + 'students/class-change-log/' + encodeURIComponent(id), owner, success, failure);
    }

	getSupportTicketStatusList(  owner:any , success:any , failure:any ){
		var url = this.newContextPath+"common/solutionstatus/list";
		this.makeGetHttpCall( url , owner , success , failure );
	}

	saveSupportTicketComment( commentRef:any , owner:any , success:any , failure:any){		
		var url = this.newContextPath+"system/save/supportticketcomment";
        this.makePostHttpCall( url , commentRef , owner , success, failure);
	}
    updateCourseComponentAndUploadV2(value:any, owner:any , success:any , failure:any ){
        let headers = new Headers();
        let formData: FormData = new FormData();
        if( value.file!=undefined)
            formData.append("file", value.file );
            formData.append("componentId", value.componentId);
            formData.append("componentName", value.componentName);
			formData.append("description", value.description);
			formData.append("courseCode", value.courseCode);
        this.makePostHttpCall( this.tanzeel.serviceUrls.course.updateAndUploadCourseComponent.toString() , formData , owner , success , failure,headers );

    }

	getStudentClassPerformanceList( ){
		var ajax = new XMLHttpRequest();
		var url = this.newContextPath+"notes/studentclassperformance/list";
		ajax.open("get" , url , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getStudentClassPerformanceList") != null) {
			//console.info(" Gender List is cached list ");
			return this.getCachedObject("getStudentClassPerformanceList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getStudentClassPerformanceList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

	getStudentClassAttitudeList( ){
		var ajax = new XMLHttpRequest();
		var url = this.newContextPath+"notes/studentclassattitude/list";
		ajax.open("get" , url , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getStudentClassAttitudeList") != null) {
			//console.info(" Gender List is cached list ");
			return this.getCachedObject("getStudentClassAttitudeList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getStudentClassAttitudeList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

	getStudentClassRecommendationList( ){
		var ajax = new XMLHttpRequest();
		var url = this.newContextPath+"notes/studentclassrecommendation/list";
		ajax.open("get" , url , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getStudentClassRecommendationList") != null) {
			//console.info(" Gender List is cached list ");
			return this.getCachedObject("getStudentClassRecommendationList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getStudentClassRecommendationList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

	getQuranSurahList( ){
		var ajax = new XMLHttpRequest();
		var url = this.newContextPath+"notes/quransurah/list";
		ajax.open("get" , url , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getQuranSurahList") != null) {
			return this.getCachedObject("getQuranSurahList")
		}
		
		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getQuranSurahList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

	getTeacherAttendanceReport( teacherId:any , date:any  , sortby:any , owner:any , success:any , failure:any){		
		var url = this.contextPath+"controller//teacher/view/teacher/attendancereport/" +  teacherId + "/" + date  + "/"+sortby;
		
        this.makeGetHttpCall( url , owner , success, failure);
	}

	getTeacherAttendanceMonthlyReport( teacherId:any , date:any , includeDetails:boolean , owner:any , success:any , failure:any){
		var url = this.newContextPath+"course/teacher/attendance/monthly/" + teacherId + "/" + date + "?includeDetails=" + includeDetails;
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getTeacherAttendanceRangeReport( teacherId:any , fromDate:any , toDate:any , includeDetails:boolean , owner:any , success:any , failure:any){
		var url = this.newContextPath+"course/teacher/attendance/monthly/" + teacherId
			+ "?from=" + fromDate + "&to=" + toDate + "&includeDetails=" + includeDetails;
		this.makeGetHttpCall( url , owner , success , failure);
	}

	getTeacherAttendanceMonthlyAllReport( date:any , teacherFilter:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"course/teacher/attendance/monthly/all/" + date;
		if( teacherFilter != null && teacherFilter !== '' && teacherFilter !== 'all' ){
			url += "?teacherFilter=" + teacherFilter;
		}
		this.makeGetHttpCall( url , owner , success , failure);
	}

	saveTeacherScheduleManualFix(val:any , extendsToNextDay:boolean , owner:any , success:any , failure:any){
        var url = this.contextPath+"/controller/teacher/save/teacherschedule/fix/"+extendsToNextDay;
        this.makePostHttpCall( url , val , owner , success , failure  , this.getTrialCsrfHeader()  );
	}

	getChatChannels( username:any ,  owner:any , success:any , failure:any){		
		var url = "/tanzeelchat/controller/chat/view/channellist";
		
        this.makePostHttpCall( url, username , owner , success, failure);
	}

	getChatChannelForUsers( body:any[] ,  owner:any , success:any , failure:any){		
		var url = "/tanzeelchat/controller/chat/view/channelforusers";
		
        this.makePostHttpCall( url, body , owner , success, failure);
	}

	getAuthUserNameFromId(userId: string, owner:any, success:any , failure:any ) {
		var url = this.contextPath+"controller/system//view/authuser/fullname" ;
		
        this.makePostHttpCall( url , userId, owner , success, failure);
	} 

	markChatMessageRead( msgIds: any, owner:any , success: any, failure: any) {
		var url = "/tanzeelchat/controller/chat/mark/chatmessageread" ;
		
        this.makePostHttpCall( url , msgIds, owner , success, failure);
	}
	
	getAllStudentUserIdListForTeacher(owner:any , success:any , failure:any ) {
		var url = this.tanzeel.contextPath+"controller/teacher/view/getstudentidlist" ;
        this.makePostHttpCall( url , this.tanzeel.secureUser.username,  owner , success, failure);
	}


	updateAttendanceMarking(meetingRef:any , owner:any , success:any , failure:any ) {
		var meetingId = meetingRef && meetingRef.id != null ? meetingRef.id : meetingRef.meetingId;
		var markAttended = meetingRef && meetingRef.markAttended === true;
		var reason = meetingRef && (meetingRef.attendanceReason || meetingRef.reason);
		var meetingAppTypeId = meetingRef && meetingRef.meetingAppTypeId;
		var url = this.newContextPath+"course/meeting/" + meetingId + "/manual-attendance";
		this.makePostHttpCall( url , { markAttended: markAttended, reason: reason, meetingAppTypeId: meetingAppTypeId }, owner , success, failure);
	}

	updateMeetingMarkAttended(meetingId:any , markAttended:boolean , reason:string , owner:any , success:any , failure:any ) {
		var url = this.newContextPath+"course/meeting/" + meetingId + "/manual-attendance";
		this.makePostHttpCall( url , { markAttended: markAttended, reason: reason }, owner , success, failure);
	}

	getTeacherAttendanceReportHTML( tscObj:any , owner:any , success:any , failure:any){
		var url = this.contextPath+"controller/teacher/report/html/getteacherattendancereport";		
        this.makePostHttpCall( url , tscObj, owner , success, failure );
	}

	getStudentAdditionalInfo( studentId : number , owner:any , success:any , failure:any ){

        this.getLoggedInStudentAsync( studentId , owner , success , failure );
	}

	saveStudentAdditionalInfo( data:any , sendEmail:boolean, owner:any , success:any , failure:any ){
        var url = this.newContextPath+"students/student/saveStudentAddlInfo/"+sendEmail;
		this.makePostHttpCall( url , data , owner , success , failure);
	}

	saveStudentProfile(data: any, owner: any, success: any, failure: any) {
		var url = this.newContextPath+ "students/profilescreen/update";
		this.makePostHttpCall( url , data , owner , success , failure);
	}

	viewLastTrialTeacherForStudent(studentId : number , owner:any , success:any , failure:any ){
        var str = this.newContextPath+"students/view/lasttrialteacherforstudent/"+studentId;
		this.makeGetHttpCall( str , owner , success , failure );
	}

	saveTrialStudentExitSurvey( survey:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"students/student/posttrial/savetrialsurvey";
        this.makePostHttpCall( url , survey , owner , success , failure);
	}

	getTeacherById( teacherId:any , owner:any , success:any , failure:any){
		var url = this.tanzeel.teacher.viewTeacherDetailScreen.toString().replace("{id}",""+teacherId);
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getTeacherByUtilizationRate(id: any, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + 'teachers/search/classinfov1/' + id;
		this.makePostHttpCall(url, {}, owner, success, failure);
	}

	getTeacherSchedulesForInterval(
		teacherId: number,
		intervalStart: string,
		intervalEnd: string,
		owner: any,
		success: any,
		failure: any,
	): void {
		var url =
			this.newContextPath +
			'teachers/schedule/' +
			teacherId +
			'/' +
			intervalStart +
			'/' +
			intervalEnd +
			'?randomdUINumber=' +
			Math.random() * 100000;
		this.makeGetHttpCall(url, owner, success, failure);
	}

	searchStudentClassInfoV2(sc:any , owner:any , success:any , failure:any){
		var url = this.newContextPath+"teachers/search/classinfov2";
		this.makePostHttpCall( url , sc , owner , success , failure );
	}

	searchUserPastNotification(userId:any , owner:any , success:any , failure:any){
		var url = this.tanzeel.common.viewPastUserNotifications.toString();
		url = url.replace("#userId" , userId);
		this.makeGetHttpCall( url , owner , success , failure );
	}

	getTeacherLanguageList( ){
        
        var ajax = new XMLHttpRequest();
		var url = this.newContextPath+"common/teacherlanguage/list";
        ajax.open("get" , url , false);
				var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);

		if( this.getCachedObject("getTeacherLanguageList") != null) {
				//console.info(" Gender List is cached list ");
				return this.getCachedObject("getTeacherLanguageList")
		}
        try {
            ajax.send();
            var responseText = ajax.responseText;
            var obj = JSON.parse(responseText);
			this.setCachedObject("getTeacherLanguageList" , obj);
             return obj;
        } catch (e) {
            console.info( e );
            return [];
        }

    }

	decodeJwt(token) {
		const base64Url = token.split('.')[1]; // Get payload part
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Convert to valid Base64
		const jsonPayload = decodeURIComponent(
			atob(base64)
			.split('')
			.map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
			.join('')
		);
		return JSON.parse(jsonPayload);
	}

	isProduction():boolean{
		return (!/localhost/.test(document.location.host) && document.location.host.indexOf("192.168.1")==-1) ;
	}

	extractAuthTokenFromResponse(body:any):string|null {
		body = this.parseJsonBody(body);
		if( body == null ){
			return null;
		}
		if( typeof body === 'string' ){
			return body;
		}
		const token = body.token;
		return token != null && token !== '' ? token : null;
	}

	getJwtRole(tokenDecoded:any):string {
		if( tokenDecoded == null ){
			return '';
		}
		return tokenDecoded.role
			?? tokenDecoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
			?? tokenDecoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/role']
			?? '';
	}

	normalizeStudentEnrollmentTarget(target:string):string {
		const normalized = String(target ?? '').replace(/^\/+/, '').replace(/\/+$/, '');
		if( normalized === '' || normalized === 'student' || normalized === 'r' ){
			return 'student/r';
		}
		if( normalized.startsWith('student/d') ){
			return normalized;
		}
		if( normalized.startsWith('student/r') ){
			return normalized;
		}
		if( normalized.startsWith('student/') ){
			return `student/r/${normalized.substring('student/'.length)}`;
		}
		return normalized;
	}

	getStudentNavigateTarget(tokenDecoded:any , authBody?:any):string {
		const fromBody = authBody?.nextAction?.target ?? authBody?.NextAction?.Target;
		if( fromBody != null && fromBody !== '' ){
			return this.normalizeStudentEnrollmentTarget(String(fromBody));
		}

		const navigateTo = tokenDecoded?.navigateTo;
		if( navigateTo == null ){
			return 'student/r';
		}
		if( typeof navigateTo === 'string' ){
			return this.normalizeStudentEnrollmentTarget(navigateTo);
		}
		if( typeof navigateTo === 'object' ){
			if( navigateTo.target != null && navigateTo.target !== '' ){
				return this.normalizeStudentEnrollmentTarget(String(navigateTo.target));
			}
			if( navigateTo.message != null && navigateTo.message !== '' ){
				return 'student/r';
			}
		}
		return 'student/r';
	}

	getStaffDevBaseUrl():string {
		const host = this.tanzeel?.host;
		if( host != null && host !== '' ){
			return String(host).replace(/\/$/, '');
		}
		return `${this.hostName}:4201`;
	}

	processNavigate( token:any , mms:{ info(msg:string):void } , authBody?:any ) {
		if( token == null || token === '' ){
			console.error('[processNavigate] missing jwt token');
			return;
		}

		let tokenDecoded:any = null;
		try {
			tokenDecoded = this.decodeJwt( token );
		} catch (e) {
			console.error('[processNavigate] failed to decode jwt', e);
			return;
		}

		const role = this.getJwtRole(tokenDecoded).toLowerCase();
		const studentTarget = this.getStudentNavigateTarget(tokenDecoded, authBody);
		const portNumber = window.location.port ? `:${window.location.port}/` : "/";

		if( this.isProduction() == true ){
			var url = `${this.hostName}${portNumber}`;
			if( role === "teacher" ){
				window.location.replace(`${url}staff/#/teacher/`);
			}else if( role === "student" ){
				const message = authBody?.nextAction?.message ?? authBody?.NextAction?.Message;
				if( message != null && String(message).trim() !== "" ){
					mms.info( String(message) );
				}
				window.location.replace(`${url}#/${studentTarget.replace(/^\/+/, '')}`);
			}else {
				window.location.replace(`${url}staff/#/admin/`);
			}
		}else{
			var studentUrl = `${this.hostName}${portNumber}`;
			const staffBase = this.getStaffDevBaseUrl();
			const encodedToken = encodeURIComponent(token);

			if( role === "teacher" ){
				window.location.replace(`${staffBase}/teacher?token=${encodedToken}`);
			}else if( role === "student" ){
				window.location.replace(`${studentUrl}#/${studentTarget.replace(/^\/+/, '')}`);
			}else {
				window.location.replace(`${staffBase}/?token=${encodedToken}`);
			}
		}

	}

	sendStudentCardPaymentToken(restData:any, owner:any , success:any , failure:any ){
        var url = this.newContextPath+"students/student/enrollment/savestudentcard"
        this.makePostHttpCall( url , restData , owner , success , failure); 
	}

	getTeacherChannels(teacherId: number, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + `chat/channels/teacher`;
		var data = { teacherId: teacherId };
		this.makePostHttpCall(url, data, owner, success, failure);
	}

	getAdminChannels(adminId: number, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + `chat/channels/admin`;
		var data = { teacherId: adminId };
		this.makePostHttpCall(url, data, owner, success, failure);
	}

	getOrCreateChannel(teacherId: number, studentId: number, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + `chat/channel`;
		var data = { teacherId: teacherId, studentId: studentId };
		this.makePostHttpCall(url, data, owner, success, failure);
	}

	getChannelMessages(channelId: number, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + `chat/channel/${channelId}/messages`;
		this.makeGetHttpCall(url, owner, success, failure);
	}

	getChannelPreview(channelId: number, currentUsername: string, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + `chat/channel/${channelId}/preview?currentUsername=${encodeURIComponent(currentUsername)}`;
		this.makeGetHttpCall(url, owner, success, failure);
	}

	markChannelMessagesAsRead(channelId: number, currentUsername: string, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + `chat/channel/${channelId}/markAsRead`;
		var data = { currentUsername: currentUsername };
		this.makePostHttpCall(url, data, owner, success, failure);
	}

	getAuthUsersByUserId(restData:any, owner:any , success:any , failure:any ){
        var url = this.newContextPath+"common/authuser/by/userids";
        this.makePostHttpCall( url , restData , owner , success , failure); 
	}
	getCustomerSupportId(owner: any, success: any, failure: any): void {
		var url = this.newContextPath + `chat/channels/customer-support`;
		this.makeGetHttpCall(url, owner, success, failure);
	}

	getJwtTokenForStudentProfile(studentId:any , owner:any , success:any , failure:any ){
		var url = this.newContextPath+"common/staff/generatejwttoken/"+studentId;
		this.makePostHttpCall( url , {}, owner , success , failure);	
	}

	updateMeetingJoiningStatus(meetingId:any, message:string ){
		var url = this.newContextPath+"course/update/meetingjoining";
		this.makePostHttpCall( url , {id : meetingId, tanzeelMeetingId : message } , null , null , null);	
	}
	getSearchCriteriaDataType( datatype:any ):string {
		var ret:any = "String";
		if( datatype==1 ){
			ret = "Int32";
		}
		else if( datatype==2 ){
			ret= "Double";
		}
		else if( datatype==3 ){
			ret= "DateOnly";
		}
		else if( datatype==4 ){
			ret= "DateTime";
		}
		else if( datatype==5 ){
			ret= "bool";
		}
		else if( datatype==5 ){
			ret= "bool";
		}
		else 
			ret = undefined;
		return ret;
	}

	getSearchCriteriaCondType( condtype:any ):number {
		var ret = 0;
		if( condtype==1 ){
			ret = 1;
		}
		return ret;
	}

	getSearchCriteriaCompareType( condtype:any ):number {
		var ret:any = 0;
		if( condtype!=null && condtype==1 ){
			ret = 1;
		}
		else if( condtype!=null && condtype==2 ){
			ret = 5;
		}
		else if( condtype!=null && condtype==3 ){
			ret = 6;
		}
		else if( condtype!=null && condtype==4 ){
			ret = 9;
		}
		else if( condtype!=null && condtype==5 ){
			ret = 10;
		}
		else if( condtype!=null && condtype==6 ){
			ret = 11;
		}
		else if( condtype!=null && condtype==7 ){
			ret = 8;
		}else{
			ret = undefined;
		}
		return ret;
	}

	// Equal, Like, GTEQ 2 > 5 , LTEQ 3> 6, Between 4 > 9, Null 5> 10, NotNull 6 > 11, IN 7 > 8, 

	activateTrialSurveyForm(meetId: any, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + `students/student/activate/trialsurveyform/`+meetId;
		this.makePostHttpCall(url, {}, owner, success, failure);
	}

	getArabicTajweedTopicList(){
		var ajax = new XMLHttpRequest();
		ajax.open("get" , this.newContextPath+"common/arabic-tajweed-topic/list" , false);
		var jwt = this.getValidJwtToken();
		if( jwt == null )
			jwt = "";
		ajax.setRequestHeader('Authorization', `Bearer ${jwt}`);
		if( this.getCachedObject("getArabicTajweedTopicList") != null) {
			return this.getCachedObject("getArabicTajweedTopicList")
		}

		try {
			ajax.send();
			var responseText = ajax.responseText;
			var obj = JSON.parse(responseText);
			this.setCachedObject("getArabicTajweedTopicList" , obj);
			 return obj;
		} catch (e) {
			console.info( e );
			return [];
		}
	}

	saveTrialClassSummary(report: any, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + "teachers/trial-class-summary/save";
		this.makePostHttpCall(url, report, owner, success, failure);
	}

	getTrialClassSummaryById(id: any, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + "teachers/trial-class-summary/" + id;
		this.makeGetHttpCall(url, owner, success, failure);
	}

	getTrialClassSummaryByAppointment(appointmentId: any, owner: any, success: any, failure: any): void {
		var url = this.newContextPath + "teachers/trial-class-summary/by-appointment/" + appointmentId;
		this.makeGetHttpCall(url, owner, success, failure);
	}

	private static readonly dataTypeMap: Record<number, string> = {
		0: "String",   // String
		1: "Int32",    // Integer
		2: "Decimal",  // Decimal
		3: "DateTime", // Date
		4: "DateTime", // Time
		5: "Boolean",  // Boolean
		6: "Long"      // Long
	};

	private static readonly compareTypeMap: Record<number, string> = {
		0: "Equals",      // Equal
		1: "Contains",    // Like
		2: "GreaterThan", // GTEQ
		3: "LessThan",    // LTEQ
		4: "Between",     // Between
		5: "IsNull",      // Null
		6: "IsNotNull",   // NotNull
		7: "In"           // IN
	};

	private static readonly condTypeMap: Record<number, string> = {
			0: "And",
			1: "Or"
	};

	static getDataType(code: number): string {
		return this.dataTypeMap[code] ?? "String";
	}

	static getCompareType(code: number): string {
		return this.compareTypeMap[code] ?? "Equals";
	}

	static getCondType(code: number): string {
		return this.condTypeMap[code] ?? "And";
	}

	toFilterRequestVO(
  		searchCriteria: LegacySearchCriteria[] = [],
  		pageCriteria: LegacyPageCriteria = {}
		) {


		return {
			pageSize: pageCriteria.maxRowsPerPage ?? 99999,
			pageNumber: pageCriteria.currentPage ?? 1,
			filters: searchCriteria.map((sc) => {
			const dataType =
				typeof sc.dataType === "number"
				? CommonAdminService.getDataType(sc.dataType)
				: (sc.dataType ?? "String");

			const operation =
				typeof sc.compareType === "number"
				? CommonAdminService.getCompareType(sc.compareType)
				: (sc.compareType ?? "Equals");

			const condition =
				typeof sc.condType === "number"
				? CommonAdminService.getCondType(sc.condType)
				: (sc.condType ?? "And");

			// Legacy Java used value1/value2. Current C# uses Value/Value1.
			// For Between in your TeacherNotes flow: Value1=from, Value=to.
			const isBetween = operation === "Between";

			return {
				property: sc.fieldName,
				operation,
				dataType,
				condition,
				value: isBetween ? (sc.value ?? null) : (sc.value1 ?? null),
				value1: isBetween ? (sc.value1 ?? null) : null
			};
			})
		};
		}

	loginIntoStrapiCMS(){
		var url = this.tanzeel.strapi + "api/auth/local";

		return fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				identifier: "lms-embed@tanzeel.org",
				password: "tanzeellms1"
			})
		}).then((response) => {
			return response.json().then((resp) => {
				//console.info( " strapi login response : "+ JSON.stringify( resp )+" \t "+ resp.jwt );
				sessionStorage.setItem("strapi_jwt", resp.jwt);
				return resp;
			});
		});
	}

}

export type LegacySearchCriteria = {
  fieldName: string;
  dataType?: number | string; // old SearchCriteria.DataType
  compareType?: number | string; // old SearchCriteria.CompareType
  value?: unknown;
  value1?: unknown;
  value2?: unknown;
  condType?: number | string; // And/Or
};

export type LegacyPageCriteria = {
  maxRowsPerPage?: number;
  currentPage?: number;
};
